import React, { useState, useEffect, useContext, useRef } from 'react'
import { AuthContext } from '../../Context'
import { AuthContextApi } from '../../Context/api'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import './styles.css'
import {
    PlusIcon,
    MagnifyingGlassIcon,
    XMarkIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    CubeIcon,
    PhotoIcon,
    TagIcon,
    WrenchScrewdriverIcon,
    CheckCircleIcon,
    XCircleIcon,
    InformationCircleIcon,
    StarIcon,
    BuildingOfficeIcon,
    ArchiveBoxIcon,
    TruckIcon,
    EnvelopeIcon
} from '@heroicons/react/24/outline'
import moment from 'moment'
import ZoomableImageModal from '../../Components/ZoomableImageModal'

const Produtos = () => {
    const { states, setters } = useContext(AuthContext)
    const { getProdutos, postProdutos, getProdutosHistorico,
        getLocalizacoesProprietario,
        getDepartamentos,
        putProdutos,
        getNextCodigoNet,
        getEquipamentos, getMarcas,
        getEquipamentosformatos,
        getFornecedores,
        getCamposPersonalizados,
        getProdutosCamposByCampos,
        getProdutosCampos,
        getEntidades,
        exportarListaEmail
    } = useContext(AuthContextApi)
    const navigate = useNavigate()

    // Estados locais
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedFilterField, setSelectedFilterField] = useState('codigo_net')
    const [selectedSortField, setSelectedSortField] = useState('codigo_net')
    const [sortDirection, setSortDirection] = useState('asc')
    const [recordsPerPage, setRecordsPerPage] = useState(10)
    const [isModalOpen, setIsModalOpen] = useState(false)

    // Estados para busca dinâmica
    const [isDynamicSearch, setIsDynamicSearch] = useState(false)
    const [dynamicCharacteristics, setDynamicCharacteristics] = useState([])
    const [selectedCharacteristic, setSelectedCharacteristic] = useState('')
    const [selectedValue, setSelectedValue] = useState('')
    const [availableValues, setAvailableValues] = useState([])
    const [loadingDynamicData, setLoadingDynamicData] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [selectedProduto, setSelectedProduto] = useState(null)
    const [isHistoricoModalOpen, setIsHistoricoModalOpen] = useState(false)
    const [isViewModalOpen, setIsViewModalOpen] = useState(false)
    const [viewProduto, setViewProduto] = useState(null)
    const [hoveredButton, setHoveredButton] = useState(null)
    const [nextCodigoNet, setNextCodigoNet] = useState(null)
    const [historicoMovimentacoes, setHistoricoMovimentacoes] = useState([])
    const [loadingHistorico, setLoadingHistorico] = useState(false)

    // Estados para filtros específicos
    const [selectedStatus, setSelectedStatus] = useState('')
    const [selectedCondicao, setSelectedCondicao] = useState('')

    // Estados para busca por cliente
    const [isSearchingClient, setIsSearchingClient] = useState(false)
    const [clientSearchTerm, setClientSearchTerm] = useState('')
    const [clientSearchResults, setClientSearchResults] = useState([])
    const [selectedClient, setSelectedClient] = useState(null)
    const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false)
    const [loadingClientSearch, setLoadingClientSearch] = useState(false)

    // Estados do formulário
    const [produtoModelo, setProdutoModelo] = useState('')
    const [produtoStatus, setProdutoStatus] = useState(1)
    const [produtoSerial, setProdutoSerial] = useState('')
    const [produtoEquipamentoId, setProdutoEquipamentoId] = useState('')
    const [produtoEquipamentoFormatoId, setProdutoEquipamentoFormatoId] = useState('')
    const [produtoMarcaId, setProdutoMarcaId] = useState('')
    const [produtoCondicao, setProdutoCondicao] = useState(0)
    const [produtoObservacao, setProdutoObservacao] = useState('')
    const [produtoFornecedorId, setProdutoFornecedorId] = useState('')
    const [produtoNotaFiscal, setProdutoNotaFiscal] = useState('')
    const [produtoNotaFiscalFile, setProdutoNotaFiscalFile] = useState(null)
    const [previewNotaFiscal, setPreviewNotaFiscal] = useState('')
    const [produtoDataAquisicao, setProdutoDataAquisicao] = useState('')
    const [produtoLocalizacaoId, setProdutoLocalizacaoId] = useState('')
    const [produtoDepartamentoId, setProdutoDepartamentoId] = useState('')


    // Estados para selects
    const [equipamentos, setEquipamentos] = useState([])
    const [equipamentoFormatos, setEquipamentoFormatos] = useState([])
    const [marcas, setMarcas] = useState([])
    const [fornecedoresData, setFornecedoresData] = useState([])
    const [localizacoes, setLocalizacoes] = useState([])
    const [departamentos, setDepartamentos] = useState([])

    const [loadingSelects, setLoadingSelects] = useState(false)

    // Estado para produto sendo editado
    const [produtoEmEdicao, setProdutoEmEdicao] = useState(null)

    // Estados para imagens
    const [produtoFoto1, setProdutoFoto1] = useState(null)
    const [produtoFoto2, setProdutoFoto2] = useState(null)
    const [produtoFoto3, setProdutoFoto3] = useState(null)
    const [previewFoto1, setPreviewFoto1] = useState('')
    const [previewFoto2, setPreviewFoto2] = useState('')
    const [previewFoto3, setPreviewFoto3] = useState('')
    const [foto1Alterada, setFoto1Alterada] = useState(false)
    const [foto2Alterada, setFoto2Alterada] = useState(false)
    const [foto3Alterada, setFoto3Alterada] = useState(false)
    const [notaFiscalAlterada, setNotaFiscalAlterada] = useState(false)

    // Estados para histórico
    const [produtoHistorico, setProdutoHistorico] = useState([])

    // Estados para modal de imagem expandida
    const [isImageModalOpen, setIsImageModalOpen] = useState(false)
    const [expandedImage, setExpandedImage] = useState('')
    const [expandedImageAlt, setExpandedImageAlt] = useState('')

    // Estados para campos opcionais
    const [camposOpcionaisAtivados, setCamposOpcionaisAtivados] = useState(false)
    const [camposPersonalizadosDisponiveis, setCamposPersonalizadosDisponiveis] = useState([])
    const [camposSelecionados, setCamposSelecionados] = useState([])
    const [valoresCamposOpcionais, setValoresCamposOpcionais] = useState({})
    const [loadingCamposPersonalizados, setLoadingCamposPersonalizados] = useState(false)
    const [camposExistentes, setCamposExistentes] = useState([]) // Campos que já existem no produto (não podem ser removidos)
    const [idsSelecionados, setIdsSelecionados] = useState([])
    const [isExportModalOpen, setIsExportModalOpen] = useState(false)
    const emailUsuario = localStorage.getItem('usuario') || ''

    // Opções de filtro
    const filterOptions = [
        { value: 'cliente', label: 'Cliente' },
        { value: 'codigo_net', label: 'Código NET' },
        { value: 'departamento_atual_nome', label: 'Departamento' },
        { value: 'local_atual_nome', label: 'Localização' },
        { value: 'marca_nome', label: 'Marca' },
        { value: 'modelo', label: 'Modelo' },
        { value: 'equipamento_nome', label: 'Nome do Equipamento' },
        { value: 'equipamento_formato_nome', label: 'Nome do Formato do Equipamento' },
        { value: 'observacao', label: 'Observação' },
        { value: 'serial', label: 'Serial' }
    ]

    // Opções de ordenação
    const sortOptions = [
        { value: 'codigo_net', label: 'Código NET' },
        { value: 'data_atualizacao', label: 'Data de Atualização' },
        { value: 'data_criacao', label: 'Data de Criação' }
    ]

    // Função para carregar características dinâmicas
    const loadDynamicCharacteristics = async () => {
        setLoadingDynamicData(true)
        try {
            const result = await getProdutosCampos()
            if (result && result.data) {
                // Agrupar características por ID e nome
                const groupedCharacteristics = {}
                result.data.forEach(item => {
                    const key = `${item.caracteristica_id}-${item.caracteristica_nome}`
                    if (!groupedCharacteristics[key]) {
                        groupedCharacteristics[key] = {
                            id: item.caracteristica_id,
                            nome: item.caracteristica_nome,
                            valores: []
                        }
                    }
                    // Adicionar valor único se não existir
                    if (!groupedCharacteristics[key].valores.includes(item.resposta)) {
                        groupedCharacteristics[key].valores.push(item.resposta)
                    }
                })

                const characteristicsArray = Object.values(groupedCharacteristics)
                characteristicsArray.forEach((item) => {
                    item.valores.sort((a, b) => String(a || '').localeCompare(String(b || ''), 'pt-BR'))
                })
                characteristicsArray.sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR'))
                setDynamicCharacteristics(characteristicsArray)
            }
        } catch (error) {
            toast.error('Erro ao carregar características dinâmicas')
        } finally {
            setLoadingDynamicData(false)
        }
    }

    // Função para buscar clientes/entidades
    const searchClients = async (searchTerm) => {
        if (!searchTerm || searchTerm.trim().length < 2) {
            setClientSearchResults([])
            setIsClientDropdownOpen(false)
            return
        }

        setLoadingClientSearch(true)
        try {
            const query = new URLSearchParams({
                filter: 'nome',
                search: searchTerm.trim(),
                per_page: 100
            }).toString()

            const result = await getEntidades(query)
            if (result) {
                setClientSearchResults(Array.isArray(result) ? [...result].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')) : result)
                setIsClientDropdownOpen(true)
            } else {
                setClientSearchResults([])
                setIsClientDropdownOpen(false)
            }
        } catch (error) {
            toast.error('Erro ao buscar clientes')
            setClientSearchResults([])
            setIsClientDropdownOpen(false)
        } finally {
            setLoadingClientSearch(false)
        }
    }

    // Função para selecionar cliente
    const selectClient = (client) => {
        setSelectedClient(client)
        setClientSearchTerm(client.nome)
        setIsClientDropdownOpen(false)
        setClientSearchResults([])

        // Resetar página para 0 e realizar busca automática
        if (setters.setPage) {
            setters.setPage(0)
        }
        loadProdutos()
    }

    // Função para limpar seleção de cliente
    const clearClientSelection = () => {
        setSelectedClient(null)
        setClientSearchTerm('')
        setClientSearchResults([])
        setIsClientDropdownOpen(false)

        // Recarregar produtos com parâmetros normais
        if (setters.setPage) {
            setters.setPage(0)
        }
        loadProdutos()
    }

    // Função para buscar produtos por características
    const searchProductsByCharacteristics = async () => {
        if (!selectedCharacteristic || !selectedValue) {
            toast.error('Selecione uma característica e um valor para buscar')
            return
        }

        try {
            const result = await getProdutosCamposByCampos(selectedCharacteristic, selectedValue)
            if (result && result.length > 0) {
                // Resetar página para 0 quando buscar
                if (setters.setPage) {
                    setters.setPage(0)
                }
                toast.success(`${result.length} produto(s) encontrado(s)`)
            } else {
                // Resetar página para 0 quando não encontrar
                if (setters.setPage) {
                    setters.setPage(0)
                }
                toast.info('Nenhum produto encontrado com essas características')
            }
        } catch (error) {
            toast.error('Erro ao buscar produtos por características')
        }
    }

    // Função para carregar produtos
    const loadProdutos = async () => {
        // Se está em busca dinâmica, não carrega produtos normais
        if (isDynamicSearch) {
            return
        }

        let searchValue = searchTerm || ''
        let filterField = selectedFilterField

        // Se o filtro for status ou condicao, usar o valor do select correspondente
        if (selectedFilterField === 'status') {
            searchValue = selectedStatus
        } else if (selectedFilterField === 'condicao') {
            searchValue = selectedCondicao
        }

        // Se o filtro for cliente e há um cliente selecionado, usar busca por entidade_atual_id
        if (selectedFilterField === 'cliente' && selectedClient) {
            filterField = 'entidade_atual_id'
            searchValue = selectedClient.id
        }

        const query = new URLSearchParams({
            page: states.page || 0,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection,
            filter: filterField,
            search: searchValue
        }).toString()

        await getProdutos(query)
    }

    // Função para carregar dados dos selects
    const loadSelectData = async () => {
        setLoadingSelects(true)
        try {

            // Carregar equipamentos
            const equipamentosQuery = new URLSearchParams({
                per_page: 100,
                sort: 'nome',
                sort_dir: 'asc'
            }).toString()
            const equipamentosResult = await getEquipamentos(equipamentosQuery)

            // Carregar marcas
            const marcasQuery = new URLSearchParams({
                per_page: 100,
                sort: 'nome',
                sort_dir: 'asc'
            }).toString()
            const marcasResult = await getMarcas(marcasQuery)

            // Carregar fornecedores específicos
            const fornecedoresDataQuery = new URLSearchParams({
                per_page: 100,
                sort: 'nome',
                sort_dir: 'asc'
            }).toString()
            const fornecedoresDataResult = await getFornecedores(fornecedoresDataQuery)

            // Aguardar um pouco para os estados serem atualizados
            setTimeout(() => {
                // Verificar se os dados foram carregados corretamente
                if (states.dataEquipamentos && Array.isArray(states.dataEquipamentos) && states.dataEquipamentos.length > 0) {
                    setEquipamentos([...states.dataEquipamentos].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')))
                } else {
                    // Tentar carregar novamente se falhou
                    setTimeout(() => {
                        if (states.dataEquipamentos && Array.isArray(states.dataEquipamentos)) {
                            setEquipamentos([...states.dataEquipamentos].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')))
                        }
                    }, 500)
                }

                if (states.dataMarcas && Array.isArray(states.dataMarcas) && states.dataMarcas.length > 0) {
                    setMarcas([...states.dataMarcas].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')))
                } else {
                    // Tentar carregar novamente se falhou
                    setTimeout(() => {
                        if (states.dataMarcas && Array.isArray(states.dataMarcas)) {
                            setMarcas([...states.dataMarcas].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')))
                        }
                    }, 500)
                }

                if (states.dataFornecedores && Array.isArray(states.dataFornecedores) && states.dataFornecedores.length > 0) {
                    setFornecedoresData([...states.dataFornecedores].sort((a, b) => String(`${a.nome || ''} - ${a.email || ''}`).localeCompare(String(`${b.nome || ''} - ${b.email || ''}`), 'pt-BR')))
                } else {
                    // Tentar carregar novamente se falhou
                    setTimeout(() => {
                        if (states.dataFornecedores && Array.isArray(states.dataFornecedores)) {
                            setFornecedoresData([...states.dataFornecedores].sort((a, b) => String(`${a.nome || ''} - ${a.email || ''}`).localeCompare(String(`${b.nome || ''} - ${b.email || ''}`), 'pt-BR')))
                        }
                    }, 500)
                }
            }, 300)

        } catch (error) {
            toast.error('Erro ao carregar dados dos formulários')
        } finally {
            setLoadingSelects(false)
        }
    }

    // Função para carregar formatos de equipamento
    const loadEquipamentoFormatos = async (equipamentoId) => {
        if (!equipamentoId) {
            setEquipamentoFormatos([])
            return
        }

        try {
            const query = new URLSearchParams({
                equipamento_id: equipamentoId,
                per_page: 100
            }).toString()

            const formatosResult = await getEquipamentosformatos(query, equipamentoId)
            // Usar diretamente o resultado retornado
            if (formatosResult) {
                setEquipamentoFormatos(Array.isArray(formatosResult.formatos) ? [...formatosResult.formatos].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')) : formatosResult.formatos)
            } else {
                setEquipamentoFormatos([])
            }

        } catch (error) {
            toast.error('Erro ao carregar formatos do equipamento')
            setEquipamentoFormatos([])
        }
    }

    // Função para carregar campos personalizados
    const loadCamposPersonalizados = async (query) => {
        setLoadingCamposPersonalizados(true)
        try {
            const response = await getCamposPersonalizados(query)
            if (response) {
                setCamposPersonalizadosDisponiveis(response)
                return response
            } else {
                setCamposPersonalizadosDisponiveis([])
                return []
            }
        } catch (error) {
            toast.error('Erro ao carregar campos personalizados')
            setCamposPersonalizadosDisponiveis([])
            return []
        } finally {
            setLoadingCamposPersonalizados(false)
        }
    }

    // Função para ativar/desativar campos opcionais
    const handleToggleCamposOpcionais = async (ativado) => {
        setCamposOpcionaisAtivados(ativado)

        if (ativado) {
            // Carregar campos personalizados quando ativar
            const query = new URLSearchParams({
                per_page: 100,
                sort: 'nome',
                sort_dir: 'asc'
            }).toString()
            await loadCamposPersonalizados(query)
        } else {
            // Limpar dados quando desativar, mas manter campos existentes se estiver editando
            if (isEditMode && camposExistentes.length > 0) {
                // Se estiver editando e houver campos existentes, não permitir desativar
                toast.warning('Não é possível desativar campos opcionais quando o produto possui características existentes')
                setCamposOpcionaisAtivados(true)
                return
            }

            // Limpar dados quando desativar
            setCamposSelecionados([])
            setValoresCamposOpcionais({})
            setCamposPersonalizadosDisponiveis([])
            setCamposExistentes([])
        }
    }

    // Função para selecionar/deselecionar campo
    const handleToggleCampoSelecionado = (campo) => {
        const isSelected = camposSelecionados.some(c => c.id === campo.id)
        const isExisting = camposExistentes.some(c => c.id === campo.id)

        if (isSelected) {
            // Verificar se é um campo existente (não pode ser removido)
            if (isExisting) {
                toast.warning('Este campo já existe no produto e não pode ser removido')
                return
            }

            // Remover campo selecionado
            setCamposSelecionados(prev => prev.filter(c => c.id !== campo.id))
            // Remover valor do campo
            setValoresCamposOpcionais(prev => {
                const newValues = { ...prev }
                delete newValues[campo.slug]
                return newValues
            })
        } else {
            // Adicionar campo selecionado
            setCamposSelecionados(prev => [...prev, campo])
            // Inicializar valor vazio
            setValoresCamposOpcionais(prev => ({
                ...prev,
                [campo.slug]: ''
            }))
        }
    }

    // Função para atualizar valor do campo opcional
    const handleUpdateValorCampo = (slug, valor) => {
        setValoresCamposOpcionais(prev => ({
            ...prev,
            [slug]: valor
        }))
    }

    // Função para carregar departamentos quando localização for selecionada
    const loadDepartamentos = async (localizacaoId) => {
        if (!localizacaoId) {
            setDepartamentos([])
            setProdutoDepartamentoId('')
            return
        }

        try {
            setLoadingSelects(true)
            const response = await getDepartamentos(localizacaoId)
            if (response) {
                setDepartamentos(Array.isArray(response) ? [...response].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')) : response)
            } else {
                setDepartamentos([])
            }
        } catch (error) {
            setDepartamentos([])
        } finally {
            setLoadingSelects(false)
        }
    }

    // Função para buscar
    const handleSearch = () => {
        // Validar se filtro de cliente está selecionado mas não há cliente escolhido
        if (selectedFilterField === 'cliente' && !selectedClient) {
            toast.error('Selecione um cliente antes de buscar')
            return
        }

        // Sempre resetar página para 0 ao buscar
        if (setters.setPage) {
            setters.setPage(0)
        }
        loadProdutos()
    }

    // Função para limpar busca
    const handleClear = () => {
        // Limpar todos os campos de busca normal
        setSearchTerm('')
        setSelectedFilterField('modelo')
        setSelectedSortField('data_criacao')
        setSortDirection('desc')
        setRecordsPerPage(10)
        setSelectedStatus('')
        setSelectedCondicao('')

        // Limpar campos de busca dinâmica
        setSelectedCharacteristic('')
        setSelectedValue('')
        setAvailableValues([])

        // Limpar seleção de cliente
        clearClientSelection()

        // Resetar página
        if (setters.setPage) {
            setters.setPage(0)
        }

        // Carregar todos os produtos (como se fosse a primeira vez na página)
        loadProdutos()
    }

    // Função para carregar histórico do produto
    const loadProdutoHistorico = async (produtoId) => {
        setLoadingHistorico(true)
        try {
            const historicoResult = await getProdutosHistorico(produtoId)
            if (historicoResult) {
                setProdutoHistorico(historicoResult)
            } else {
                setProdutoHistorico([])
            }
        } catch (error) {
            toast.error('Erro ao carregar histórico do produto')
            setProdutoHistorico([])
        } finally {
            setLoadingHistorico(false)
        }
    }

    // Função para abrir modal de histórico
    const openHistoricoModal = async (produto) => {
        setSelectedProduto(produto)
        setIsHistoricoModalOpen(true)
        await loadProdutoHistorico(produto.id)
    }

    // Função para fechar modal de histórico
    const closeHistoricoModal = () => {
        setIsHistoricoModalOpen(false)
        setProdutoHistorico([])
        setSelectedProduto(null)
    }

    // Função para abrir modal de visualização
    const openViewModal = (produto) => {
        setViewProduto(produto)
        setIsViewModalOpen(true)
    }

    // Função para fechar modal de visualização
    const closeViewModal = () => {
        setIsViewModalOpen(false)
        setViewProduto(null)
    }

    // Função para abrir modal de imagem expandida
    const openImageModal = (imageSrc, imageAlt = 'Imagem do Produto') => {
        setExpandedImage(imageSrc)
        setExpandedImageAlt(imageAlt)
        setIsImageModalOpen(true)
    }

    // Função para fechar modal de imagem expandida
    const closeImageModal = () => {
        setIsImageModalOpen(false)
        setExpandedImage('')
        setExpandedImageAlt('')
    }

    // Função para próxima página
    const handleNext = () => {
        if (setters.setPage) {
            setters.setPage((states.page) + 1)
        }
    }

    // Função para página anterior
    const handlePrevious = () => {
        if (setters.setPage && states.page >= 0) {
            setters.setPage(states.page - 1)
        }
    }

    // Função para abrir modal
    const openModal = async (produto = null) => {
        setIsEditMode(!!produto)
        setSelectedProduto(produto)

        if (produto) {

            // Salvar produto completo para edição
            setProdutoEmEdicao(produto)
            // Setar estados com dados do produto
            setProdutoModelo(produto.modelo || '')
            setProdutoStatus(produto.status)
            setProdutoSerial(produto.serial || '')
            setProdutoEquipamentoId(produto.equipamento_id || '')
            setProdutoEquipamentoFormatoId(produto.equipamento_formato_id || '')
            setProdutoMarcaId(produto.marca_id || '')
            setProdutoFornecedorId(produto.fornecedor_id || '')
            setProdutoNotaFiscal(produto.numero_nota || '')
            setProdutoDataAquisicao(produto.data_aquisicao ? moment(produto.data_aquisicao).format('YYYY-MM-DD') : '')
            setProdutoCondicao(produto.condicao || 0)
            setProdutoObservacao(produto.observacao || '')
            setProdutoLocalizacaoId(produto.local_atual_id || '')
            setProdutoDepartamentoId(produto.departamento_atual_id || '')

            // Carregar fotos existentes
            if (produto.path_foto1 && produto.path_foto1 !== 'null' && produto.path_foto1 !== 'base64' && produto.path_foto1.length > 100) {
                setPreviewFoto1(`data:image/webp;base64,${produto.path_foto1}`)
            }
            if (produto.path_foto2 && produto.path_foto2 !== 'null' && produto.path_foto2 !== 'base64' && produto.path_foto2.length > 100) {
                setPreviewFoto2(`data:image/webp;base64,${produto.path_foto2}`)
            }
            if (produto.path_foto3 && produto.path_foto3 !== 'null' && produto.path_foto3 !== 'base64' && produto.path_foto3.length > 100) {
                setPreviewFoto3(`data:image/webp;base64,${produto.path_foto3}`)
            }

            // Carregar nota fiscal existente
            if (produto.nota_path && produto.nota_path !== 'null' && produto.nota_path !== 'base64' && produto.nota_path.length > 100) {
                setPreviewNotaFiscal(`data:application/pdf;base64,${produto.nota_path}`)
            }

            // Carregar formatos do equipamento selecionado (se houver)
            if (produto.equipamento_id) {
                loadEquipamentoFormatos(produto.equipamento_id)
            }

            // Na edição, não carregamos localizações nem departamentos

            // Carregar características existentes se houver
            if (produto.caracteristicas && produto.caracteristicas.length > 0) {
                // Ativar campos opcionais
                setCamposOpcionaisAtivados(true)

                // Carregar campos personalizados disponíveis
                const query = new URLSearchParams({
                    page: states.page,
                    per_page: 100
                }).toString()
                const response = await loadCamposPersonalizados(query)

                if (response && response.length > 0) {

                    // Mapear características para campos personalizados
                    const camposExistentesMapeados = produto.caracteristicas.map(caracteristica => {
                        // Encontrar o campo personalizado correspondente pelo slug
                        const campoPersonalizado = response.find(campo => {
                            // Tentar diferentes formas de mapear
                            const slugFromChave = caracteristica.caracteristica_chave.toLowerCase().replace(/\s+/g, '-')
                            const matchBySlug = campo.slug === slugFromChave
                            const matchByName = campo.nome.toLowerCase() === caracteristica.caracteristica_chave.toLowerCase()
                            return matchBySlug || matchByName
                        })

                        if (campoPersonalizado) {
                            return {
                                ...campoPersonalizado,
                                valorExistente: caracteristica.caracteristica_valor
                            }
                        }
                        return null
                    }).filter(Boolean)


                    // Definir campos existentes
                    setCamposExistentes(camposExistentesMapeados)

                    // Adicionar campos existentes aos selecionados
                    setCamposSelecionados(camposExistentesMapeados)

                    // Preencher valores existentes
                    const valoresExistentes = {}
                    camposExistentesMapeados.forEach(campo => {
                        valoresExistentes[campo.slug] = campo.valorExistente
                    })
                    setValoresCamposOpcionais(valoresExistentes)
                }
            }
        } else {
            resetForm()
            setProdutoEmEdicao(null)
            // Buscar próximo código NET para novo produto
            try {
                const response = await getNextCodigoNet()
                if (response) {
                    setNextCodigoNet(response.nextCodigoNet)
                }
            } catch (error) {
                setNextCodigoNet(null)
            }

            // Carregar localizações para novo produto
            try {
                const query = new URLSearchParams({
                    page: 0,
                    per_page: 100
                }).toString()
                const localizacoesResponse = await getLocalizacoesProprietario(query)
                if (localizacoesResponse) {
                    setLocalizacoes(Array.isArray(localizacoesResponse) ? [...localizacoesResponse].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')) : localizacoesResponse)
                }
            } catch (error) {
                setLocalizacoes([])
            }
        }

        setIsModalOpen(true)
    }

    // Função para fechar modal
    const closeModal = () => {
        setIsModalOpen(false)
        setIsEditMode(false)
        setSelectedProduto(null)
        resetForm()
    }


    // Função para resetar formulário
    const resetForm = () => {
        setProdutoModelo('')
        setProdutoStatus(1)
        setProdutoSerial('')
        setProdutoEquipamentoId('')
        setProdutoEquipamentoFormatoId('')
        setProdutoMarcaId('')
        setProdutoFornecedorId('')
        setProdutoNotaFiscal('')
        setProdutoDataAquisicao('')
        setProdutoCondicao(0)
        setProdutoObservacao('')

        // Limpar URL do PDF se existir
        if (previewNotaFiscal && previewNotaFiscal.startsWith('blob:')) {
            URL.revokeObjectURL(previewNotaFiscal)
        }
        setProdutoNotaFiscalFile(null)
        setPreviewNotaFiscal('')

        // Limpar previews das fotos
        setPreviewFoto1('')
        setPreviewFoto2('')
        setPreviewFoto3('')

        setProdutoFoto1(null)
        setProdutoFoto2(null)
        setProdutoFoto3(null)
        setPreviewFoto1('')
        setPreviewFoto2('')
        setPreviewFoto3('')
        setFoto1Alterada(false)
        setFoto2Alterada(false)
        setFoto3Alterada(false)
        setNotaFiscalAlterada(false)
        setProdutoLocalizacaoId('')
        setProdutoDepartamentoId('')
        setDepartamentos([])

        // Limpar campos opcionais
        setCamposOpcionaisAtivados(false)
        setCamposSelecionados([])
        setValoresCamposOpcionais({})
        setCamposPersonalizadosDisponiveis([])
        setCamposExistentes([])
    }

    // Função para salvar produto
    const handleSaveProduto = async () => {

        // Usar dados do produto em edição se estiver editando
        const dadosParaValidar = isEditMode && produtoEmEdicao ? {
            modelo: produtoModelo,
            serial: produtoSerial,
            status: produtoStatus,// || produtoEmEdicao.status,
            equipamento_id: produtoEquipamentoId || produtoEmEdicao.equipamento_id,
            equipamento_formato_id: produtoEquipamentoFormatoId || produtoEmEdicao.equipamento_formato_id,
            marca_id: produtoMarcaId || produtoEmEdicao.marca_id,
            fornecedor_id: produtoFornecedorId || produtoEmEdicao.fornecedor_id,
            nota_fiscal: produtoNotaFiscal || produtoEmEdicao.nota_fiscal,
            data_aquisicao: produtoDataAquisicao || produtoEmEdicao.data_aquisicao,
            condicao: produtoCondicao || produtoEmEdicao.condicao,
            observacao: produtoObservacao || produtoEmEdicao.observacao,
            // Na edição, não enviamos localização nem departamento
            isEditMode: isEditMode
        } : {
            modelo: produtoModelo,
            status: produtoStatus,
            serial: produtoSerial,
            equipamento_id: produtoEquipamentoId,
            equipamento_formato_id: produtoEquipamentoFormatoId,
            marca_id: produtoMarcaId,
            fornecedor_id: produtoFornecedorId,
            nota_fiscal: produtoNotaFiscal,
            data_aquisicao: produtoDataAquisicao,
            condicao: produtoCondicao,
            observacao: produtoObservacao,
            localizacao_id: produtoLocalizacaoId,
            departamento_id: produtoDepartamentoId,
            isEditMode: isEditMode
        }

        // Validações usando dados corretos
        if (!dadosParaValidar.modelo || !dadosParaValidar.modelo.trim()) {
            toast.error('Modelo é obrigatório')
            return
        }

        if (!dadosParaValidar.serial || !dadosParaValidar.serial.trim()) {
            toast.error('Serial é obrigatório')
            return
        }

        if (!isEditMode) {
            if (!dadosParaValidar.localizacao_id) {
                toast.error('Localização é obrigatória')
                return
            }
            if (!dadosParaValidar.departamento_id) {
                toast.error('Departamento é obrigatório')
                return
            }
        }

        if (!dadosParaValidar.equipamento_id) {
            toast.error('Equipamento é obrigatório')
            return
        }

        if (!dadosParaValidar.equipamento_formato_id) {
            toast.error('Formato do equipamento é obrigatório')
            return
        }

        // Verificar se o equipamento selecionado possui formatos
        if (equipamentoFormatos && equipamentoFormatos.length === 0) {
            toast.error('Este equipamento não possui formatos cadastrados. É necessário cadastrar formatos antes de criar produtos.')
            return
        }

        if (!dadosParaValidar.marca_id) {
            toast.error('Marca é obrigatória')
            return
        }

        if (!dadosParaValidar.fornecedor_id && !isEditMode) {
            toast.error('Fornecedor é obrigatório')
            return
        }

        if (!dadosParaValidar.nota_fiscal && !isEditMode) {
            toast.error('Número da nota fiscal é obrigatório')
            return
        }

        if (!produtoNotaFiscalFile && !isEditMode) {
            toast.error('Arquivo da nota fiscal é obrigatório')
            return
        }

        if (!dadosParaValidar.data_aquisicao && !isEditMode) {
            toast.error('Data de aquisição é obrigatória')
            return
        }

        // Validar se a data de aquisição não é no futuro
        if (dadosParaValidar.data_aquisicao) {
            const dataAquisicao = new Date(dadosParaValidar.data_aquisicao)
            const hoje = new Date()
            hoje.setHours(23, 59, 59, 999) // Permitir até o final do dia atual

            if (dataAquisicao > hoje) {
                toast.error('Data de aquisição não pode ser no futuro')
                return
            }
        }

        // Verificar se pelo menos uma imagem foi enviada (obrigatório apenas no cadastro)
        const fotos = []
        if (produtoFoto1) fotos.push(produtoFoto1)
        if (produtoFoto2) fotos.push(produtoFoto2)
        if (produtoFoto3) fotos.push(produtoFoto3)

        if (fotos.length === 0 && !isEditMode) {
            toast.error('Pelo menos uma imagem do produto é obrigatória')
            return
        }

        // Validar campos opcionais
        if (camposOpcionaisAtivados && camposSelecionados.length > 0) {
            for (const campo of camposSelecionados) {
                const valor = valoresCamposOpcionais[campo.slug]
                if (!valor || !valor.trim()) {
                    toast.error(`Campo "${campo.nome}" é obrigatório`)
                    return
                }
                if (valor.trim().length > 100) {
                    toast.error(`Campo "${campo.nome}" deve ter no máximo 100 caracteres`)
                    return
                }
            }
        }

        let formData = null;

        if (isEditMode) {
            formData = new FormData()
            formData.append('modelo', dadosParaValidar.modelo)
            formData.append('status', dadosParaValidar.status)
            formData.append('serial', dadosParaValidar.serial)
            formData.append('equipamento_id', dadosParaValidar.equipamento_id)
            formData.append('equipamento_formato_id', dadosParaValidar.equipamento_formato_id)
            formData.append('marca_id', dadosParaValidar.marca_id)
            formData.append('fornecedor_id', dadosParaValidar.fornecedor_id)
            formData.append('numero_nota', dadosParaValidar.nota_fiscal)
            formData.append('data_aquisicao', dadosParaValidar.data_aquisicao)
            formData.append('condicao', dadosParaValidar.condicao)
            formData.append('observacao', dadosParaValidar.observacao)
            formData.append('localizacao_id', dadosParaValidar.localizacao_id)
            formData.append('departamento_id', dadosParaValidar.departamento_id)

            // Adicionar parâmetros booleanos para as fotos
            formData.append('foto1', foto1Alterada)
            formData.append('foto2', foto2Alterada)
            formData.append('foto3', foto3Alterada)

            // Adicionar fotos alteradas
            if (foto1Alterada && produtoFoto1) {
                formData.append('images', produtoFoto1)
            }
            if (foto2Alterada && produtoFoto2) {
                formData.append('images', produtoFoto2)
            }
            if (foto3Alterada && produtoFoto3) {
                formData.append('images', produtoFoto3)
            }

            // Adicionar nota fiscal apenas se foi alterada
            if (notaFiscalAlterada && produtoNotaFiscalFile) {
                formData.append('nota', produtoNotaFiscalFile)
            }

            // Adicionar campos opcionais se houver
            if (camposOpcionaisAtivados && camposSelecionados.length > 0) {
                const opcionaisArray = camposSelecionados.map(campo => ({
                    [campo.slug]: valoresCamposOpcionais[campo.slug]
                }))
                formData.append('opcionais', JSON.stringify(opcionaisArray))
            }
        } else {
            formData = new FormData()
            formData.append('modelo', dadosParaValidar.modelo)
            formData.append('status', dadosParaValidar.status)
            formData.append('serial', dadosParaValidar.serial)
            formData.append('equipamento_id', dadosParaValidar.equipamento_id)
            formData.append('equipamento_formato_id', dadosParaValidar.equipamento_formato_id)
            formData.append('marca_id', dadosParaValidar.marca_id)
            formData.append('fornecedor_id', dadosParaValidar.fornecedor_id)
            formData.append('numero_nota', dadosParaValidar.nota_fiscal)
            formData.append('data_aquisicao', dadosParaValidar.data_aquisicao)
            formData.append('condicao', dadosParaValidar.condicao)
            formData.append('observacao', dadosParaValidar.observacao)
            formData.append('localizacao_id', dadosParaValidar.localizacao_id)
            formData.append('departamento_id', dadosParaValidar.departamento_id)

            // Adicionar o array de fotos ao FormData
            fotos.forEach((foto, index) => {
                formData.append(`images`, foto)
            })

            // Adicionar nota fiscal se houver
            if (produtoNotaFiscalFile) {
                formData.append(`nota`, produtoNotaFiscalFile)
            }

            // Adicionar campos opcionais se houver
            if (camposOpcionaisAtivados && camposSelecionados.length > 0) {
                const opcionaisArray = camposSelecionados.map(campo => ({
                    [campo.slug]: valoresCamposOpcionais[campo.slug]
                }))
                formData.append('opcionais', JSON.stringify(opcionaisArray))
            }
        }




        const success = isEditMode
            ? await putProdutos(formData, selectedProduto.id)
            : await postProdutos(formData)


        if (success) {
            closeModal()
            loadProdutos()
        } else {
        }
    }

    // Função para lidar com upload de imagem
    const handleImageUpload = (file, setImage, setPreview, previewState, setFotoAlterada) => {
        if (file) {
            setImage(file)
            const reader = new FileReader()
            reader.onload = (e) => setPreview(e.target.result)
            reader.readAsDataURL(file)
            if (setFotoAlterada) {
                setFotoAlterada(true) // Marcar como alterada
            }
        }
    }

    // Função específica para upload de fotos em modo de edição
    const handleEditImageUpload = (file, fotoNumber) => {
        if (file) {
            const reader = new FileReader()
            reader.onload = (e) => {
                if (fotoNumber === 1) {
                    setProdutoFoto1(file)
                    setPreviewFoto1(e.target.result)
                    setFoto1Alterada(true)
                } else if (fotoNumber === 2) {
                    setProdutoFoto2(file)
                    setPreviewFoto2(e.target.result)
                    setFoto2Alterada(true)
                } else if (fotoNumber === 3) {
                    setProdutoFoto3(file)
                    setPreviewFoto3(e.target.result)
                    setFoto3Alterada(true)
                }
            }
            reader.readAsDataURL(file)
        }
    }

    // Função para lidar com upload de nota fiscal
    const handleNotaFiscalUpload = (file) => {
        if (file) {
            // Verificar se é um PDF
            if (file.type !== 'application/pdf') {
                toast.error('Apenas arquivos PDF são aceitos para a nota fiscal')
                return
            }

            // Limpar URL anterior se existir
            if (previewNotaFiscal && previewNotaFiscal.startsWith('blob:')) {
                URL.revokeObjectURL(previewNotaFiscal)
            }

            setProdutoNotaFiscalFile(file)

            // Criar URL para pré-visualização do PDF
            const pdfUrl = URL.createObjectURL(file)
            setPreviewNotaFiscal(pdfUrl)
            setNotaFiscalAlterada(true) // Marcar como alterada
        }
    }

    // Função para obter ícone do status
    const getStatusIcon = (status) => {
        return status === 1 ? CheckCircleIcon : XCircleIcon
    }

    // Função para obter cor do status
    const getStatusColor = (status) => {
        return status === 1 ? 'text-green-500' : 'text-red-500'
    }





    // Função para obter texto da condição
    const getCondicaoText = (condicao) => {
        switch (condicao) {
            case 0: return 'Novo'
            case 1: return 'Usado'
            case 2: return 'Vendido'
            case 3: return 'Baixa'
            case 5: return 'Manutenção'
            default: return 'Desconhecido'
        }
    }

    // Função para obter background do card
    const getCardBackground = (produto) => {
        if (produto.status === 0) return 'bg-gradient-to-br from-red-50 to-red-100'
        if (produto.condicao === 5) return 'bg-gradient-to-br from-orange-50 to-orange-100'
        if (produto.condicao === 2) return 'bg-gradient-to-br from-green-50 to-green-100'
        if (produto.condicao === 3) return 'bg-gradient-to-br from-gray-50 to-gray-100'
        return 'bg-gradient-to-br from-blue-50 to-blue-100'
    }

    // useEffect para carregar produtos iniciais
    useEffect(() => {
        loadProdutos()

        loadSelectData()
    }, []) // Executa apenas uma vez na montagem do componente



    // useEffect para recarregar produtos quando variáveis de paginação mudarem
    useEffect(() => {
        if (states.page >= 0 && states.dataProdutos.length > 0) { // Evita recarregar na primeira montagem
            loadProdutos()
        }
    }, [states.page, recordsPerPage, selectedSortField, sortDirection])

    // useEffect para carregar formatos quando equipamento mudar (removido - agora é feito no onChange do select)

    // useEffect para carregar dados dos selects quando modal abrir
    useEffect(() => {
        if (isModalOpen) {
            loadSelectData()
        }
    }, [isModalOpen])


    // useEffect para sincronizar estados quando modal abrir em modo de edição
    useEffect(() => {
        if (isModalOpen && isEditMode && produtoEmEdicao) {

            // Garantir que os estados estejam sincronizados
            setProdutoModelo(produtoEmEdicao.modelo || '')
            setProdutoStatus(produtoEmEdicao.status)
            setProdutoSerial(produtoEmEdicao.serial || '')
            setProdutoEquipamentoId(produtoEmEdicao.equipamento_id || '')
            setProdutoEquipamentoFormatoId(produtoEmEdicao.equipamento_formato_id || '')
            setProdutoMarcaId(produtoEmEdicao.marca_id || '')
            setProdutoFornecedorId(produtoEmEdicao.fornecedor_id || '')
            setProdutoNotaFiscal(produtoEmEdicao.numero_nota || '')
            setProdutoDataAquisicao(moment(produtoEmEdicao.data_aquisicao).format('YYYY-MM-DD') || '')
            setProdutoCondicao(produtoEmEdicao.condicao || 0)
            setProdutoObservacao(produtoEmEdicao.observacao || '')


        }
    }, [isModalOpen, isEditMode, produtoEmEdicao])

    // useEffect para limpar valores dos filtros quando o campo de filtro mudar
    useEffect(() => {
        if (selectedFilterField !== 'status') {
            setSelectedStatus('')
        }
        if (selectedFilterField !== 'condicao') {
            setSelectedCondicao('')
        }
        if (selectedFilterField !== 'cliente') {
            clearClientSelection()
        }
        if (selectedFilterField === 'status' || selectedFilterField === 'condicao' || selectedFilterField === 'cliente') {
            setSearchTerm('')
        }
    }, [selectedFilterField])

    // useEffect para limpar URLs de objetos quando componente for desmontado
    useEffect(() => {
        return () => {
            if (previewNotaFiscal && previewNotaFiscal.startsWith('blob:')) {
                URL.revokeObjectURL(previewNotaFiscal)
            }
        }
    }, [previewNotaFiscal])

    // useEffect para carregar características quando ativar busca dinâmica
    useEffect(() => {
        if (isDynamicSearch && dynamicCharacteristics.length === 0) {
            loadDynamicCharacteristics()
        }
    }, [isDynamicSearch])

    // useEffect para carregar todos os produtos quando sair do modo avançado
    useEffect(() => {
        if (!isDynamicSearch) {
            // Limpar campos de busca dinâmica
            setSelectedCharacteristic('')
            setSelectedValue('')
            setAvailableValues([])

            // Carregar todos os produtos como se fosse a primeira vez
            loadProdutos()
        }
    }, [isDynamicSearch])

    // useEffect para atualizar valores disponíveis quando selecionar característica
    useEffect(() => {
        if (selectedCharacteristic) {
            const characteristic = dynamicCharacteristics.find(c => c.id === selectedCharacteristic)
            if (characteristic) {
                setAvailableValues([...characteristic.valores].sort((a, b) => String(a || '').localeCompare(String(b || ''), 'pt-BR')))
                setSelectedValue('') // Limpar valor selecionado
            }
        } else {
            setAvailableValues([])
            setSelectedValue('')
        }
    }, [selectedCharacteristic, dynamicCharacteristics])

    // useEffect para fechar dropdown de clientes quando clicar fora
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isClientDropdownOpen && !event.target.closest('.client-search-container')) {
                setIsClientDropdownOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [isClientDropdownOpen])

    const idsPaginaProdutos = (states.dataProdutos || []).map(p => String(p.id))
    const paginaTodaSelecionada = idsPaginaProdutos.length > 0 && idsPaginaProdutos.every(id => idsSelecionados.includes(id))

    const toggleSelecaoProduto = (e, id) => {
        e.stopPropagation()
        const idStr = String(id)
        if (idsSelecionados.includes(idStr)) {
            setIdsSelecionados(idsSelecionados.filter(item => item !== idStr))
            return
        }
        setIdsSelecionados([...idsSelecionados, idStr])
    }

    const toggleSelecaoPaginaProdutos = (e) => {
        e.stopPropagation()
        if (paginaTodaSelecionada) {
            setIdsSelecionados(idsSelecionados.filter(id => !idsPaginaProdutos.includes(id)))
            return
        }
        const novos = [...idsSelecionados]
        idsPaginaProdutos.forEach(id => {
            if (!novos.includes(id)) novos.push(id)
        })
        setIdsSelecionados(novos)
    }

    const confirmarExportacaoProdutos = async () => {
        if (idsSelecionados.length === 0) return
        const ok = await exportarListaEmail({ tipo: 'produto', ids: idsSelecionados })
        if (!ok) return
        setIsExportModalOpen(false)
        setIdsSelecionados([])
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4">
            {/* Header */}
            <div className="mb-8">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6 space-y-4 lg:space-y-0">
                    <div className="flex items-center space-x-4">
                        <div className="p-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl shadow-lg">
                            <CubeIcon className="w-8 h-8 text-white" />
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                                Produtos
                            </h1>
                            <p className="text-gray-600">Gerencie seu inventário de produtos</p>
                        </div>
                    </div>

                    <div className="flex flex-col space-y-3">
                        {/* Botões de Alternância de Busca - Mobile First */}
                        <div className="flex items-center justify-center bg-gray-50 rounded-xl p-1 shadow-sm border border-gray-200">
                            <button
                                onClick={() => setIsDynamicSearch(false)}
                                className={`flex items-center justify-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex-1 ${!isDynamicSearch
                                    ? 'bg-white text-blue-600 shadow-sm border border-blue-200'
                                    : 'text-gray-600 hover:text-gray-800'
                                    }`}
                            >
                                <MagnifyingGlassIcon className="w-4 h-4" />
                                <span className="text-xs sm:text-sm">Normal</span>
                            </button>
                            <button
                                onClick={() => setIsDynamicSearch(true)}
                                className={`flex items-center justify-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex-1 ${isDynamicSearch
                                    ? 'bg-white text-purple-600 shadow-sm border border-purple-200'
                                    : 'text-gray-600 hover:text-gray-800'
                                    }`}
                            >
                                <WrenchScrewdriverIcon className="w-4 h-4" />
                                <span className="text-xs sm:text-sm">Características</span>
                            </button>
                        </div>

                        {idsSelecionados.length > 0 && (
                            <button
                                onClick={() => setIsExportModalOpen(true)}
                                className="flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 w-full sm:w-auto"
                            >
                                <EnvelopeIcon className="w-5 h-5" />
                                <span>Exportar e enviar por e-mail</span>
                            </button>
                        )}

                        {/* Botão Novo Produto */}
                        <button
                            onClick={() => openModal()}
                            className="flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 w-full sm:w-auto"
                        >
                            <PlusIcon className="w-5 h-5" />
                            <span>Novo Produto</span>
                        </button>
                    </div>
                </div>
            </div>


            {/* Search Form */}
            <div className="bg-white rounded-2xl p-6 shadow-lg mb-6">
                {/* Indicador de Modo de Busca */}
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2">
                        {!isDynamicSearch ? (
                            <>
                                <MagnifyingGlassIcon className="w-5 h-5 text-blue-500" />
                                <span className="text-sm font-medium text-blue-600">Busca Normal</span>
                            </>
                        ) : (
                            <>
                                <WrenchScrewdriverIcon className="w-5 h-5 text-purple-500" />
                                <span className="text-sm font-medium text-purple-600">Busca por Características</span>
                            </>
                        )}
                    </div>
                    <div className={`px-3 py-1 rounded-full text-xs font-medium ${!isDynamicSearch
                        ? 'bg-blue-100 text-blue-700'
                        : 'bg-purple-100 text-purple-700'
                        }`}>
                        {!isDynamicSearch ? 'Modo Padrão' : 'Modo Avançado'}
                    </div>
                </div>

                {!isDynamicSearch ? (
                    <>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
                            <div className="lg:col-span-2">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Buscar</label>
                                {selectedFilterField === 'status' ? (
                                    <select
                                        value={selectedStatus}
                                        onChange={(e) => setSelectedStatus(e.target.value)}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                    >
                                        <option value="">Selecione o status</option>
                                        <option value="1">Ativo</option>
                                        <option value="0">Inativo</option>
                                    </select>
                                ) : selectedFilterField === 'condicao' ? (
                                    <select
                                        value={selectedCondicao}
                                        onChange={(e) => setSelectedCondicao(e.target.value)}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                    >
                                        <option value="">Selecione a condição</option>
                                        <option value="0">Novo</option>
                                        <option value="1">Usado</option>
                                        <option value="2">Vendido</option>
                                        <option value="3">Baixa</option>
                                        <option value="4">Mantenção</option>
                                    </select>
                                ) : selectedFilterField === 'cliente' ? (
                                    <div className="relative client-search-container">
                                        <input
                                            type="text"
                                            value={clientSearchTerm}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                setClientSearchTerm(value)
                                                if (value.length >= 2) {
                                                    searchClients(value)
                                                } else {
                                                    setClientSearchResults([])
                                                    setIsClientDropdownOpen(false)
                                                }
                                            }}
                                            onFocus={() => {
                                                if (clientSearchResults.length > 0) {
                                                    setIsClientDropdownOpen(true)
                                                }
                                            }}
                                            placeholder="Digite o nome do cliente (mín. 2 caracteres)"
                                            className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                        />

                                        {/* Loading indicator */}
                                        {loadingClientSearch && (
                                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
                                            </div>
                                        )}

                                        {/* Dropdown de resultados */}
                                        {isClientDropdownOpen && clientSearchResults.length > 0 && (
                                            <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-xl shadow-lg max-h-60 overflow-y-auto">
                                                {clientSearchResults.map((client) => (
                                                    <div
                                                        key={client.id}
                                                        onClick={() => selectClient(client)}
                                                        className="px-4 py-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors duration-200"
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div>
                                                                <p className="font-medium text-gray-900">{client.nome}</p>
                                                                {client.email && (
                                                                    <p className="text-sm text-gray-600">{client.email}</p>
                                                                )}
                                                            </div>
                                                            <div className="text-xs text-gray-500">
                                                                {client.tipo === 1 ? 'Pessoa Jurídica' : 'Pessoa Física'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="relative">
                                        <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                                        <input
                                            type={selectedFilterField === 'codigo_net' ? 'number' : 'text'}
                                            value={searchTerm}
                                            onKeyUp={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSearch()
                                                }
                                            }}
                                            onChange={(e) => {
                                                if (selectedFilterField === 'codigo_net') {
                                                    // Aceitar apenas números inteiros maiores que 0
                                                    const value = e.target.value
                                                    if (value === '' || (Number.isInteger(Number(value)) && Number(value) > 0)) {
                                                        setSearchTerm(value)
                                                    }
                                                } else {
                                                    setSearchTerm(e.target.value)
                                                }
                                            }}
                                            placeholder={selectedFilterField === 'codigo_net' ? 'Digite o código NET (ex: 123)' : 'Digite sua busca...'}
                                            min={selectedFilterField === 'codigo_net' ? '1' : undefined}
                                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                        />
                                    </div>
                                )}
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Filtrar por</label>
                                <select
                                    value={selectedFilterField}
                                    onChange={(e) => setSelectedFilterField(e.target.value)}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                >
                                    {filterOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Ordenar por</label>
                                <select
                                    value={selectedSortField}
                                    onChange={(e) => setSelectedSortField(e.target.value)}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                >
                                    {sortOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Direção</label>
                                <select
                                    value={sortDirection}
                                    onChange={(e) => setSortDirection(e.target.value)}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                >
                                    <option value="asc">Crescente</option>
                                    <option value="desc">Decrescente</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Por página</label>
                                <select
                                    value={recordsPerPage}
                                    onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>
                        </div>

                        {/* Exibir cliente selecionado quando filtro de cliente estiver ativo */}
                        {selectedFilterField === 'cliente' && selectedClient && (
                            <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-xl">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                        <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                                        <div>
                                            <p className="text-sm font-medium text-blue-800">Cliente selecionado:</p>
                                            <p className="text-lg font-semibold text-blue-900">{selectedClient.nome}</p>
                                            {selectedClient.email && (
                                                <p className="text-xs text-blue-600">{selectedClient.email}</p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        onClick={clearClientSelection}
                                        className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors duration-200"
                                    >
                                        <XMarkIcon className="w-4 h-4 inline mr-1" />
                                        Remover
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="flex justify-end space-x-4 mt-6">
                            <button
                                onClick={handleClear}
                                className="px-6 py-3 text-gray-600 bg-gray-100 rounded-2xl hover:bg-gray-200 transition-all duration-300"
                            >
                                Limpar
                            </button>
                            <button
                                onClick={handleSearch}
                                className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-2xl hover:shadow-lg transition-all duration-300"
                            >
                                Buscar
                            </button>
                        </div>
                    </>
                ) : (
                    /* Busca Dinâmica por Características */
                    <div className="space-y-6">
                        <div className="text-center">
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">🔍 Busca por Características</h3>
                            <p className="text-sm text-gray-600">Selecione uma característica e um valor para encontrar produtos específicos</p>
                        </div>

                        <div className="space-y-4">
                            {/* Seleção de Característica */}
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    <WrenchScrewdriverIcon className="w-4 h-4 inline mr-1" />
                                    Característica *
                                </label>
                                <select
                                    value={selectedCharacteristic}
                                    onChange={(e) => setSelectedCharacteristic(e.target.value)}
                                    disabled={loadingDynamicData}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed text-sm"
                                >
                                    <option value="">
                                        {loadingDynamicData ? 'Carregando características...' : 'Selecione uma característica'}
                                    </option>
                                    {dynamicCharacteristics.map((char) => (
                                        <option key={char.id} value={char.id}>
                                            {char.nome} ({char.valores.length} valores)
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Seleção de Valor */}
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    <TagIcon className="w-4 h-4 inline mr-1" />
                                    Valor *
                                </label>
                                <select
                                    value={selectedValue}
                                    onChange={(e) => setSelectedValue(e.target.value)}
                                    disabled={!selectedCharacteristic || availableValues.length === 0}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed text-sm"
                                >
                                    <option value="">
                                        {!selectedCharacteristic
                                            ? 'Selecione primeiro uma característica'
                                            : availableValues.length === 0
                                                ? 'Nenhum valor disponível'
                                                : 'Selecione um valor'
                                        }
                                    </option>
                                    {availableValues.map((value, index) => (
                                        <option key={index} value={value}>
                                            {value}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Informações da Característica Selecionada */}
                        {selectedCharacteristic && (
                            <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                                <div className="flex items-center space-x-2 mb-3">
                                    <InformationCircleIcon className="w-5 h-5 text-purple-600" />
                                    <span className="text-sm font-semibold text-purple-800">Informações da Característica</span>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-purple-700">
                                    <div className="flex flex-col">
                                        <span className="font-medium text-purple-800">Característica:</span>
                                        <span className="text-purple-600">{dynamicCharacteristics.find(c => c.id === selectedCharacteristic)?.nome}</span>
                                    </div>
                                    <div className="flex flex-col">
                                        <span className="font-medium text-purple-800">Valores disponíveis:</span>
                                        <span className="text-purple-600">{availableValues.length}</span>
                                    </div>
                                    {selectedValue && (
                                        <div className="flex flex-col sm:col-span-2">
                                            <span className="font-medium text-purple-800">Valor selecionado:</span>
                                            <span className="text-purple-600 bg-purple-100 px-2 py-1 rounded-md inline-block mt-1">{selectedValue}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Botões de Ação */}
                        <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4">
                            <button
                                onClick={() => {
                                    // Limpar campos de busca dinâmica
                                    setSelectedCharacteristic('')
                                    setSelectedValue('')
                                    setAvailableValues([])

                                    // Resetar página
                                    if (setters.setPage) {
                                        setters.setPage(0)
                                    }

                                    // Carregar todos os produtos (como se fosse a primeira vez na página)
                                    loadProdutos()
                                }}
                                className="px-6 py-3 text-gray-600 bg-gray-100 rounded-xl hover:bg-gray-200 transition-all duration-300 w-full sm:w-auto"
                            >
                                <XMarkIcon className="w-4 h-4 inline mr-1" />
                                Limpar
                            </button>
                            <button
                                onClick={searchProductsByCharacteristics}
                                disabled={!selectedCharacteristic || !selectedValue}
                                className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-xl hover:shadow-lg transition-all duration-300 disabled:bg-gray-300 disabled:cursor-not-allowed w-full sm:w-auto"
                            >
                                <MagnifyingGlassIcon className="w-4 h-4 inline mr-1" />
                                Buscar Produtos
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Products List */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-200">
                    <h2 className="text-lg font-semibold text-gray-900">Lista de Produtos</h2>
                </div>

                {states.dataProdutos && states.dataProdutos.length > 0 ? (
                    <>
                        {/* Cabeçalho da tabela - Desktop */}
                        <div className="hidden md:block px-6 py-3 bg-gray-50 border-b border-gray-200">
                            <div className="grid grid-cols-7 gap-4 items-center text-sm font-medium text-gray-700">
                                <div className="flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
                                    <input
                                        type="checkbox"
                                        checked={paginaTodaSelecionada}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={toggleSelecaoPaginaProdutos}
                                        title="Selecionar página"
                                        className="w-4 h-4 text-blue-600 border-gray-300 rounded cursor-pointer"
                                    />
                                </div>
                                <div className="flex items-center justify-center space-x-2">
                                    <span>Ações</span>
                                </div>
                                <div className="flex items-center justify-center space-x-2">
                                    <TagIcon className="w-4 h-4" />
                                    <span>Código NET</span>
                                </div>
                                <div className="flex items-center justify-center space-x-2">
                                    <TagIcon className="w-4 h-4" />
                                    <span>Cliente</span>
                                </div>
                                <div className="flex items-center justify-center space-x-2">
                                    <ArchiveBoxIcon className="w-4 h-4" />
                                    <span>Local</span>
                                </div>
                                <div className="flex items-center justify-center space-x-2">
                                    <WrenchScrewdriverIcon className="w-4 h-4" />
                                    <span>Serial</span>
                                </div>
                                <div className="flex items-center justify-center space-x-2">
                                    <InformationCircleIcon className="w-4 h-4" />
                                    <span>Atualizado</span>
                                </div>
                            </div>
                        </div>

                        {/* Lista de produtos */}
                        <div className="divide-y divide-gray-200">
                            {states.dataProdutos.map((produto) => {
                                const StatusIcon = getStatusIcon(produto.status)

                                return (
                                    <div key={produto.id}>
                                        {/* Versão Desktop */}
                                        <div className={`hidden md:block px-6 py-4 hover:bg-gray-50 transition-colors duration-200 ${getCardBackground(produto)}`}>
                                            <div className="grid grid-cols-7 gap-4 items-center">
                                                <div className="flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
                                                    <input
                                                        type="checkbox"
                                                        checked={idsSelecionados.includes(String(produto.id))}
                                                        onClick={(e) => e.stopPropagation()}
                                                        onChange={(e) => toggleSelecaoProduto(e, produto.id)}
                                                        className="w-4 h-4 text-blue-600 border-gray-300 rounded cursor-pointer"
                                                    />
                                                </div>
                                                {/* Botões de ação */}
                                                <div className="flex items-center justify-center space-x-2 relative">
                                                    <div className="relative">
                                                        <button
                                                            onClick={() => openModal(produto)}
                                                            onMouseEnter={() => setHoveredButton(`${produto.id}-edit`)}
                                                            onMouseLeave={() => setHoveredButton(null)}
                                                            className="p-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:shadow-md transition-all duration-300 transform hover:scale-105"
                                                        >
                                                            <WrenchScrewdriverIcon className="w-4 h-4" />
                                                        </button>
                                                        {hoveredButton === `${produto.id}-edit` && (
                                                            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap z-10">
                                                                Editar produto
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="relative">
                                                        <button
                                                            onClick={() => openViewModal(produto)}
                                                            onMouseEnter={() => setHoveredButton(`${produto.id}-view`)}
                                                            onMouseLeave={() => setHoveredButton(null)}
                                                            className="p-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:shadow-md transition-all duration-300 transform hover:scale-105"
                                                        >
                                                            <InformationCircleIcon className="w-4 h-4" />
                                                        </button>
                                                        {hoveredButton === `${produto.id}-view` && (
                                                            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap z-10">
                                                                Visualizar produto
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="relative">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                navigate(`/produtos/produto-cronologia/${produto.id}`)
                                                            }}
                                                            onMouseEnter={() => setHoveredButton(`${produto.id}-mov`)}
                                                            onMouseLeave={() => setHoveredButton(null)}
                                                            className="p-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:shadow-md transition-all duration-300 transform hover:scale-105"
                                                        >
                                                            <TruckIcon className="w-4 h-4" />
                                                        </button>
                                                        {hoveredButton === `${produto.id}-mov` && (
                                                            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap z-10">
                                                                Ver movimentações
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="relative">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                openHistoricoModal(produto)
                                                            }}
                                                            onMouseEnter={() => setHoveredButton(`${produto.id}-hist`)}
                                                            onMouseLeave={() => setHoveredButton(null)}
                                                            className="p-2 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-lg hover:shadow-md transition-all duration-300 transform hover:scale-105"
                                                        >
                                                            📋
                                                        </button>
                                                        {hoveredButton === `${produto.id}-hist` && (
                                                            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap z-10">
                                                                Ver histórico
                                                            </div>
                                                        )}
                                                    </div>


                                                </div>

                                                {/* Informações do produto */}
                                                <div className="text-center">
                                                    <span className="text-sm font-medium text-gray-900">#{produto.codigo_net}</span>
                                                </div>
                                                <div className="text-center">
                                                    <span className="text-sm text-gray-700 truncate">{produto.entidade_atual_nome}</span>
                                                </div>
                                                <div className="text-center">
                                                    <span className="text-sm text-gray-700 truncate">{produto.local_atual_nome}</span>
                                                </div>
                                                <div className="text-center">
                                                    <span className="text-sm text-gray-700 truncate">{produto.serial}</span>
                                                </div>
                                                <div className="text-center">
                                                    <span className="text-sm text-gray-700">{new Date(produto.data_atualizacao).toLocaleDateString('pt-BR')}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Versão Mobile */}
                                        <div className={`md:hidden px-4 py-4 hover:bg-gray-50 transition-colors duration-200 ${getCardBackground(produto)}`}>
                                            <div className="space-y-3">
                                                {/* Cabeçalho do card mobile */}
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center space-x-2">
                                                        <div onClick={(e) => e.stopPropagation()}>
                                                            <input
                                                                type="checkbox"
                                                                checked={idsSelecionados.includes(String(produto.id))}
                                                                onClick={(e) => e.stopPropagation()}
                                                                onChange={(e) => toggleSelecaoProduto(e, produto.id)}
                                                                className="w-4 h-4 text-blue-600 border-gray-300 rounded cursor-pointer"
                                                            />
                                                        </div>
                                                        <TagIcon className="w-4 h-4 text-gray-500" />
                                                        <span className="text-sm font-medium text-gray-900">#{produto.codigo_net}</span>
                                                    </div>
                                                    <StatusIcon className={`w-5 h-5 ${getStatusColor(produto.status)}`} />
                                                </div>

                                                {/* Informações principais */}
                                                <div className="space-y-2">
                                                    <div className="flex items-center space-x-2">
                                                        <ArchiveBoxIcon className="w-4 h-4 text-gray-500" />
                                                        <span className="text-sm text-gray-700">{produto.entidade_atual_nome}</span>
                                                    </div>
                                                    <div className="flex items-center space-x-2">
                                                        <CubeIcon className="w-4 h-4 text-gray-500" />
                                                        <span className="text-sm text-gray-700">{produto.local_atual_nome}</span>
                                                    </div>
                                                    <div className="flex items-center space-x-2">
                                                        <WrenchScrewdriverIcon className="w-4 h-4 text-gray-500" />
                                                        <span className="text-sm text-gray-700">{produto.serial}</span>
                                                    </div>
                                                    <div className="flex items-center space-x-2">
                                                        <InformationCircleIcon className="w-4 h-4 text-gray-500" />
                                                        <span className="text-sm text-gray-700">{new Date(produto.data_atualizacao).toLocaleDateString('pt-BR')}</span>
                                                    </div>
                                                </div>

                                                {/* Botões de ação mobile */}
                                                <div className="flex items-center justify-center space-x-2 pt-2 border-t border-gray-200">
                                                    <button
                                                        onClick={() => openModal(produto)}
                                                        className="px-3 py-1 text-xs bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:shadow-md transition-all duration-300"
                                                    >
                                                        Editar
                                                    </button>
                                                    <button
                                                        onClick={() => openViewModal(produto)}
                                                        className="px-3 py-1 text-xs bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:shadow-md transition-all duration-300"
                                                    >
                                                        Ver
                                                    </button>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            navigate(`/produtos/produto-cronologia/${produto.id}`)
                                                        }}
                                                        className="px-3 py-1 text-xs bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:shadow-md transition-all duration-300"
                                                    >
                                                        Movimentações
                                                    </button>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            openHistoricoModal(produto)
                                                        }}
                                                        className="px-3 py-1 text-xs bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-lg hover:shadow-md transition-all duration-300"
                                                    >
                                                        Histórico
                                                    </button>
                                                    {produto.mudarLocal && (
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                // TODO: Implementar funcionalidade de trocar local
                                                                toast.info('Funcionalidade de trocar local será implementada em breve')
                                                            }}
                                                            className="px-3 py-1 text-xs bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-lg hover:shadow-md transition-all duration-300"
                                                        >
                                                            Trocar Local
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </>
                ) : (
                    <div className="px-6 py-8 text-center text-gray-500">
                        Nenhum produto encontrado
                    </div>
                )}
            </div>

            {/* Empty State */}
            {(!states.dataProdutos || states.dataProdutos.length === 0) && !states.isLoading && (
                <div className="text-center py-12">
                    <CubeIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum produto encontrado</h3>
                    <p className="text-gray-600 mb-6">Comece criando seu primeiro produto</p>
                    <button
                        onClick={() => openModal()}
                        className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-2xl hover:shadow-lg transition-all duration-300"
                    >
                        Criar Produto
                    </button>
                </div>
            )}

            {/* Pagination */}
            {states.dataProdutos && states.dataProdutos.length > 0 && (
                <div className="flex items-center justify-between mt-8">
                    <div className="text-sm text-gray-700">
                        Mostrando {(((states.page || 1) - 1) * recordsPerPage) + 1} a {Math.min((states.page || 1) * recordsPerPage, states.dataProdutos?.length || 0)} de {states.dataProdutos?.length || 0} produtos
                    </div>
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={handlePrevious}
                            disabled={(states.page === 0)}
                            className="p-2 text-gray-600 bg-white rounded-lg border hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
                        >
                            <ChevronLeftIcon className="w-5 h-5" />
                        </button>
                        <span className="px-4 py-2 text-gray-700 bg-white rounded-lg border">
                            Página {states.page + 1}
                        </span>
                        <button
                            onClick={handleNext}
                            disabled={!states.dataProdutos || states.dataProdutos.length < recordsPerPage}
                            className="p-2 text-gray-600 bg-white rounded-lg border hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
                        >
                            <ChevronRightIcon className="w-5 h-5" />
                        </button>
                    </div>
                </div>
            )}

            {/* Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
                        <div className="shrink-0 border-b border-gray-200 p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h2 className="text-2xl font-bold text-gray-900">
                                        {isEditMode ? 'Editar Produto' : 'Novo Produto'}
                                    </h2>
                                    {isEditMode && selectedProduto && (
                                        <p className="text-gray-600 mt-1">
                                            {selectedProduto.modelo} - Código NET: #{selectedProduto.codigo_net}
                                        </p>
                                    )}
                                    {!isEditMode && nextCodigoNet && (
                                        <p className="text-gray-600 mt-1">
                                            Próximo Código NET: #{nextCodigoNet}
                                        </p>
                                    )}
                                </div>
                                <button
                                    onClick={closeModal}
                                    className="p-2 text-gray-400 hover:text-gray-600 transition-colors duration-300"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        <div className="min-h-0 flex-1 overflow-y-auto p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {/* Modelo */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Modelo *
                                    </label>
                                    <input
                                        type="text"
                                        value={produtoModelo}
                                        onChange={(e) => {
                                            setProdutoModelo(e.target.value)
                                        }}
                                        maxLength={150}
                                        placeholder="Digite o modelo do produto"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                    />
                                    {isEditMode && (
                                        <div className="text-xs text-gray-500 mt-1">
                                            Valor atual: {produtoModelo || 'vazio'}
                                        </div>
                                    )}
                                </div>

                                {/* Status */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Status *
                                    </label>
                                    <select
                                        value={produtoStatus}
                                        onChange={(e) => setProdutoStatus(Number(e.target.value))}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                    >
                                        <option value={1}>Ativo</option>
                                        <option value={0}>Inativo</option>
                                    </select>
                                </div>

                                {/* Serial */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Serial *
                                    </label>
                                    <input
                                        type="text"
                                        value={produtoSerial}
                                        onChange={(e) => {
                                            setProdutoSerial(e.target.value)
                                        }}
                                        placeholder="Digite o serial do produto"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                    />
                                    {isEditMode && (
                                        <div className="text-xs text-gray-500 mt-1">
                                            Valor atual: {produtoSerial || 'vazio'}
                                        </div>
                                    )}
                                </div>

                                {/* Equipamento */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Equipamento *
                                    </label>
                                    <select
                                        value={produtoEquipamentoId}
                                        onChange={async (e) => {
                                            const equipamentoId = e.target.value
                                            setProdutoEquipamentoId(equipamentoId)
                                            setProdutoEquipamentoFormatoId('') // Reset formato quando equipamento mudar

                                            if (equipamentoId) {
                                                // Carregar formatos do equipamento selecionado
                                                await loadEquipamentoFormatos(equipamentoId)
                                            } else {
                                                setEquipamentoFormatos([])
                                            }
                                        }}
                                        disabled={loadingSelects}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                    >
                                        <option value="">
                                            {loadingSelects ? 'Carregando...' : 'Selecione um equipamento'}
                                        </option>
                                        {!loadingSelects && equipamentos && equipamentos.length > 0 && equipamentos.map((equipamento) => (
                                            <option key={equipamento.id} value={equipamento.id}>
                                                {equipamento.nome}
                                            </option>
                                        ))}
                                        {!loadingSelects && (!equipamentos || equipamentos.length === 0) && (
                                            <option value="" disabled>Nenhum equipamento encontrado</option>
                                        )}
                                    </select>
                                </div>

                                {/* Formato do Equipamento */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Formato do Equipamento *
                                    </label>
                                    <select
                                        value={produtoEquipamentoFormatoId}
                                        onChange={(e) => setProdutoEquipamentoFormatoId(e.target.value)}
                                        disabled={!produtoEquipamentoId || loadingSelects}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                    >
                                        <option value="">
                                            {!produtoEquipamentoId ? 'Selecione um equipamento primeiro' :
                                                loadingSelects ? 'Carregando formatos...' : 'Selecione um formato'}
                                        </option>
                                        {equipamentoFormatos && equipamentoFormatos.length > 0 && equipamentoFormatos.map((formato) => (
                                            <option key={formato.id} value={formato.id}>
                                                {formato.nome}
                                            </option>
                                        ))}
                                        {equipamentoFormatos && equipamentoFormatos.length === 0 && produtoEquipamentoId && !loadingSelects && (
                                            <option value="" disabled>⚠️ Este equipamento não possui formatos cadastrados</option>
                                        )}
                                    </select>
                                    {equipamentoFormatos && equipamentoFormatos.length === 0 && produtoEquipamentoId && !loadingSelects && (
                                        <p className="text-xs text-red-600 mt-1">
                                            ⚠️ Este equipamento não possui formatos. É necessário cadastrar formatos antes de criar produtos.
                                        </p>
                                    )}
                                </div>

                                {/* Marca */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Marca *
                                    </label>
                                    <select
                                        value={produtoMarcaId}
                                        onChange={(e) => setProdutoMarcaId(e.target.value)}
                                        disabled={loadingSelects}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                    >
                                        <option value="">
                                            {loadingSelects ? 'Carregando...' : 'Selecione uma marca'}
                                        </option>
                                        {!loadingSelects && marcas && marcas.length > 0 && marcas.map((marca) => (
                                            <option key={marca.id} value={marca.id}>
                                                {marca.nome}
                                            </option>
                                        ))}
                                        {!loadingSelects && (!marcas || marcas.length === 0) && (
                                            <option value="" disabled>Nenhuma marca encontrada</option>
                                        )}
                                    </select>
                                </div>

                                {/* Fornecedor */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Fornecedor *
                                    </label>
                                    <select
                                        value={produtoFornecedorId}
                                        onChange={(e) => setProdutoFornecedorId(e.target.value)}
                                        disabled={loadingSelects}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                    >
                                        <option value="">
                                            {loadingSelects ? 'Carregando...' : 'Selecione um fornecedor'}
                                        </option>
                                        {!loadingSelects && fornecedoresData && fornecedoresData.length > 0 && fornecedoresData.map((fornecedor) => (
                                            <option key={fornecedor.id} value={fornecedor.id}>
                                                {fornecedor.nome} - {fornecedor.email}
                                            </option>
                                        ))}
                                        {!loadingSelects && (!fornecedoresData || fornecedoresData.length === 0) && (
                                            <option value="" disabled>Nenhum fornecedor encontrado</option>
                                        )}
                                    </select>
                                </div>

                                {/* Número da Nota Fiscal */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Número da Nota Fiscal *
                                    </label>
                                    <input
                                        type="text"
                                        value={produtoNotaFiscal}
                                        onChange={(e) => setProdutoNotaFiscal(e.target.value)}
                                        placeholder="Ex: 123456789"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                    />
                                    {isEditMode && (
                                        <div className="text-xs text-gray-500 mt-1">
                                            Valor atual: {produtoNotaFiscal || 'vazio'}
                                        </div>
                                    )}
                                </div>

                                {/* Data de Aquisição */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Data de Aquisição *
                                    </label>
                                    <input
                                        type="date"
                                        value={produtoDataAquisicao}
                                        onChange={(e) => setProdutoDataAquisicao(e.target.value)}
                                        max={new Date().toISOString().split('T')[0]}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                    />
                                </div>

                                {/* Condição */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Condição *
                                    </label>
                                    <select
                                        value={produtoCondicao}
                                        onChange={(e) => setProdutoCondicao(Number(e.target.value))}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                    >
                                        {isEditMode ? (
                                            <>
                                                <option value={0}>Novo</option>
                                                <option value={1}>Usado</option>
                                                <option value={2}>Vendido</option>
                                                <option value={3}>Baixa</option>
                                                <option value={5}>Manutenção</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value={0}>Novo</option>
                                                <option value={1}>Usado</option>
                                            </>
                                        )}
                                    </select>
                                </div>



                                {/* Observação */}
                                <div className="md:col-span-2">
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Observação
                                    </label>
                                    <textarea
                                        value={produtoObservacao}
                                        onChange={(e) => setProdutoObservacao(e.target.value)}
                                        placeholder="Digite observações sobre o produto (opcional)"
                                        rows={3}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 resize-none"
                                    />
                                </div>

                                {/* Campos Opcionais */}
                                <div className="md:col-span-2">
                                    <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-6 border border-purple-100">
                                        <div className="flex items-center space-x-3 mb-4">
                                            <input
                                                type="checkbox"
                                                id="camposOpcionais"
                                                checked={camposOpcionaisAtivados}
                                                onChange={(e) => handleToggleCamposOpcionais(e.target.checked)}
                                                className="w-5 h-5 text-purple-600 bg-gray-100 border-gray-300 rounded focus:ring-purple-500 focus:ring-2"
                                            />
                                            <label htmlFor="camposOpcionais" className="text-sm font-semibold text-gray-700 cursor-pointer">
                                                ⚙️ Campos Opcionais
                                            </label>
                                        </div>

                                        {camposOpcionaisAtivados && (
                                            <div className="space-y-4">
                                                {/* Painel de Seleção de Campos */}
                                                <div className="bg-white rounded-xl p-4 border border-purple-200">
                                                    <div className="flex items-center justify-between mb-3">
                                                        <h4 className="text-sm font-semibold text-gray-700">Selecione os campos desejados:</h4>
                                                        {camposExistentes.length > 0 && (
                                                            <span className="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded-full">
                                                                {camposExistentes.length} campo(s) existente(s)
                                                            </span>
                                                        )}
                                                    </div>
                                                    {camposExistentes.length > 0 && (
                                                        <div className="mb-3 p-3 bg-orange-50 border border-orange-200 rounded-lg">
                                                            <p className="text-xs text-orange-800">
                                                                <strong>ℹ️ Informação:</strong> Campos marcados como "Existente" já fazem parte deste produto e não podem ser removidos, apenas editados.
                                                            </p>
                                                        </div>
                                                    )}
                                                    {loadingCamposPersonalizados ? (
                                                        <div className="flex items-center justify-center py-4">
                                                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-purple-600"></div>
                                                            <span className="ml-2 text-sm text-gray-600">Carregando campos...</span>
                                                        </div>
                                                    ) : camposPersonalizadosDisponiveis.length > 0 ? (
                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                            {camposPersonalizadosDisponiveis.map((campo) => {
                                                                const isSelected = camposSelecionados.some(c => c.id === campo.id)
                                                                const isExisting = camposExistentes.some(c => c.id === campo.id)
                                                                return (
                                                                    <div
                                                                        key={campo.id}
                                                                        className={`p-3 rounded-lg border-2 transition-all duration-200 ${isSelected
                                                                            ? isExisting
                                                                                ? 'border-orange-500 bg-orange-50 cursor-not-allowed'
                                                                                : 'border-purple-500 bg-purple-50 cursor-pointer'
                                                                            : 'border-gray-200 bg-white hover:border-purple-300 hover:bg-purple-25 cursor-pointer'
                                                                            }`}
                                                                        onClick={() => !isExisting && handleToggleCampoSelecionado(campo)}
                                                                    >
                                                                        <div className="flex items-center space-x-3">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={isSelected}
                                                                                disabled={isExisting}
                                                                                onChange={() => { }} // Controlado pelo onClick do div
                                                                                className={`w-4 h-4 rounded focus:ring-purple-500 ${isExisting
                                                                                    ? 'text-orange-600 bg-orange-100 border-orange-300 cursor-not-allowed'
                                                                                    : 'text-purple-600 bg-gray-100 border-gray-300'
                                                                                    }`}
                                                                            />
                                                                            <div className="flex-1 min-w-0">
                                                                                <div className="flex items-center space-x-2">
                                                                                    <p className="text-sm font-medium text-gray-900 truncate">
                                                                                        {campo.nome}
                                                                                    </p>
                                                                                    {isExisting && (
                                                                                        <span className="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded-full">
                                                                                            Existente
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                                <p className="text-xs text-gray-500 truncate">
                                                                                    {campo.slug}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    ) : (
                                                        <div className="text-center py-4 text-gray-500">
                                                            <p className="text-sm">Nenhum campo personalizado disponível</p>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Inputs dos Campos Selecionados */}
                                                {camposSelecionados.length > 0 && (
                                                    <div className="bg-white rounded-xl p-4 border border-purple-200">
                                                        <h4 className="text-sm font-semibold text-gray-700 mb-3">Preencha os valores: ({camposSelecionados.length})</h4>
                                                        <div className="space-y-4">
                                                            {camposSelecionados.map((campo) => {
                                                                const isExisting = camposExistentes.some(c => c.id === campo.id)
                                                                const valorAtual = valoresCamposOpcionais[campo.slug] || ''


                                                                return (
                                                                    <div key={campo.id} className={`p-4 rounded-xl border-2 ${isExisting
                                                                        ? 'border-orange-200 bg-orange-50'
                                                                        : 'border-purple-200 bg-purple-50'
                                                                        }`}>
                                                                        <div className="flex items-center space-x-2 mb-2">
                                                                            <label className="text-sm font-medium text-gray-700">
                                                                                {campo.nome} *
                                                                            </label>
                                                                            {isExisting && (
                                                                                <span className="text-xs bg-orange-200 text-orange-800 px-2 py-1 rounded-full">
                                                                                    Campo Existente
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        <input
                                                                            type="text"
                                                                            value={valorAtual}
                                                                            onChange={(e) => handleUpdateValorCampo(campo.slug, e.target.value)}
                                                                            placeholder={`Digite o valor para ${campo.nome.toLowerCase()}`}
                                                                            maxLength={100}
                                                                            className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:border-transparent transition-all duration-300 ${isExisting
                                                                                ? 'border-orange-300 focus:ring-orange-500'
                                                                                : 'border-gray-300 focus:ring-purple-500'
                                                                                }`}
                                                                        />
                                                                        <div className="flex justify-between text-xs text-gray-500 mt-1">
                                                                            <span>Máximo 100 caracteres</span>
                                                                            <span className={`font-medium ${isExisting ? 'text-orange-600' : 'text-purple-600'
                                                                                }`}>
                                                                                {valorAtual.length}/100
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Localização - apenas no cadastro */}
                                {!isEditMode && (
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Localização <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            value={produtoLocalizacaoId}
                                            onChange={async (e) => {
                                                const localizacaoId = e.target.value
                                                setProdutoLocalizacaoId(localizacaoId)
                                                setProdutoDepartamentoId('') // Reset departamento quando localização mudar

                                                if (localizacaoId) {
                                                    await loadDepartamentos(localizacaoId)
                                                } else {
                                                    setDepartamentos([])
                                                }
                                            }}
                                            disabled={loadingSelects}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                        >
                                            <option value="">
                                                {loadingSelects ? 'Carregando...' : 'Selecione uma localização'}
                                            </option>
                                            {!loadingSelects && localizacoes && localizacoes.length > 0 && localizacoes.map((localizacao) => (
                                                <option key={localizacao.id} value={localizacao.id}>
                                                    {localizacao.nome}
                                                </option>
                                            ))}
                                            {!loadingSelects && (!localizacoes || localizacoes.length === 0) && (
                                                <option value="" disabled>Nenhuma localização encontrada</option>
                                            )}
                                        </select>
                                    </div>
                                )}

                                {/* Departamento - apenas no cadastro */}
                                {!isEditMode && (
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Departamento <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            value={produtoDepartamentoId}
                                            onChange={(e) => setProdutoDepartamentoId(e.target.value)}
                                            disabled={loadingSelects || !produtoLocalizacaoId}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                        >
                                            <option value="">
                                                {loadingSelects ? 'Carregando...' :
                                                    !produtoLocalizacaoId ? 'Selecione uma localização primeiro' :
                                                        'Selecione um departamento'}
                                            </option>
                                            {!loadingSelects && departamentos && departamentos.length > 0 && departamentos.map((departamento) => (
                                                <option key={departamento.id} value={departamento.id}>
                                                    {departamento.nome}
                                                </option>
                                            ))}
                                            {!loadingSelects && produtoLocalizacaoId && (!departamentos || departamentos.length === 0) && (
                                                <option value="" disabled>Nenhum departamento encontrado</option>
                                            )}
                                        </select>
                                    </div>
                                )}

                                {/* Nota Fiscal Existente (modo edição) */}
                                {isEditMode && previewNotaFiscal && !previewNotaFiscal.startsWith('blob:') && (
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-semibold text-gray-700 mb-4">
                                            📄 Nota Fiscal Atual
                                        </label>
                                        <div className="relative">
                                            <div className="group">
                                                <input
                                                    type="file"
                                                    accept=".pdf"
                                                    onChange={(e) => handleNotaFiscalUpload(e.target.files[0])}
                                                    className="hidden"
                                                    id="editNotaFiscal"
                                                />
                                                <label
                                                    htmlFor="editNotaFiscal"
                                                    className="block w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group-hover:scale-105"
                                                >
                                                    <div className="relative w-full h-full rounded-2xl overflow-hidden bg-white border-2 border-gray-200">
                                                        {/* Header com informações do arquivo */}
                                                        <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-red-500 to-red-600 text-white p-2 z-10">
                                                            <div className="flex items-center justify-between">
                                                                <div className="flex items-center space-x-2">
                                                                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                                                    </svg>
                                                                    <span className="text-xs font-medium truncate">
                                                                        {selectedProduto?.nota_arquivo || 'Nota Fiscal.pdf'}
                                                                    </span>
                                                                </div>
                                                                <span className="text-xs">PDF</span>
                                                            </div>
                                                        </div>

                                                        {/* Pré-visualização do PDF */}
                                                        <iframe
                                                            src={`${previewNotaFiscal}#toolbar=0&navpanes=0&scrollbar=1`}
                                                            className="w-full h-full border-0 mt-8"
                                                            title="Pré-visualização da Nota Fiscal Atual"
                                                            style={{ height: 'calc(100% - 2rem)' }}
                                                        />

                                                        {/* Overlay para alterar arquivo */}
                                                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-2xl flex items-center justify-center pointer-events-none">
                                                            <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-auto">
                                                                <div className="bg-white rounded-lg p-3 shadow-lg">
                                                                    <PhotoIcon className="w-6 h-6 text-gray-600 mx-auto mb-1" />
                                                                    <p className="text-gray-600 text-xs text-center">Alterar PDF</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>

                                        {/* Dica de uso para edição */}
                                        <div className="mt-4 p-4 bg-green-50 rounded-2xl border border-green-200">
                                            <div className="flex items-start space-x-3">
                                                <InformationCircleIcon className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                                                <div>
                                                    <p className="text-sm font-medium text-green-800">Edição de Nota Fiscal</p>
                                                    <p className="text-xs text-green-600 mt-1">
                                                        Clique na nota para substituí-la. A nova nota substituirá a atual.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Upload de Nota Fiscal */}
                                {(!isEditMode || (isEditMode && (!previewNotaFiscal || previewNotaFiscal.startsWith('blob:')))) && (
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-semibold text-gray-700 mb-4">
                                            📄 Nota Fiscal *
                                        </label>
                                        <div className="relative">
                                            <div className="group">
                                                <input
                                                    type="file"
                                                    accept=".pdf"
                                                    onChange={(e) => handleNotaFiscalUpload(e.target.files[0])}
                                                    className="hidden"
                                                    id="notaFiscal"
                                                />
                                                <label
                                                    htmlFor="notaFiscal"
                                                    className="block w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group-hover:scale-105"
                                                >
                                                    {previewNotaFiscal ? (
                                                        <div className="relative w-full h-full rounded-2xl overflow-hidden bg-white border-2 border-gray-200">
                                                            {/* Header com informações do arquivo */}
                                                            <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-red-500 to-red-600 text-white p-2 z-10">
                                                                <div className="flex items-center justify-between">
                                                                    <div className="flex items-center space-x-2">
                                                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                                                        </svg>
                                                                        <span className="text-xs font-medium truncate">
                                                                            {produtoNotaFiscalFile?.name || 'Nota Fiscal.pdf'}
                                                                        </span>
                                                                    </div>
                                                                    <span className="text-xs">
                                                                        {(produtoNotaFiscalFile?.size / 1024 / 1024).toFixed(2)} MB
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            {/* Pré-visualização do PDF */}
                                                            <iframe
                                                                src={`${previewNotaFiscal}#toolbar=0&navpanes=0&scrollbar=1`}
                                                                className="w-full h-full border-0 mt-8"
                                                                title="Pré-visualização da Nota Fiscal"
                                                                style={{ height: 'calc(100% - 2rem)' }}
                                                            />

                                                            {/* Overlay para alterar arquivo */}
                                                            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-2xl flex items-center justify-center pointer-events-none">
                                                                <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-auto">
                                                                    <div className="bg-white rounded-lg p-3 shadow-lg">
                                                                        <PhotoIcon className="w-6 h-6 text-gray-600 mx-auto mb-1" />
                                                                        <p className="text-gray-600 text-xs text-center">Alterar PDF</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="flex flex-col items-center justify-center h-full text-gray-500">
                                                            <PhotoIcon className="w-12 h-12 mb-2" />
                                                            <p className="text-sm font-medium">Adicionar Nota Fiscal</p>
                                                            <p className="text-xs text-gray-400 mt-1">PDF (obrigatório)</p>
                                                        </div>
                                                    )}
                                                </label>
                                            </div>
                                        </div>

                                        {/* Dica de uso para nota fiscal */}
                                        <div className="mt-4 p-4 bg-green-50 rounded-2xl border border-green-200">
                                            <div className="flex items-start space-x-3">
                                                <InformationCircleIcon className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                                                <div>
                                                    <p className="text-sm font-medium text-green-800">Dica de Upload</p>
                                                    <p className="text-xs text-green-600 mt-1">
                                                        Selecione a nota fiscal em formato PDF.
                                                        Este campo é obrigatório para controle fiscal.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Fotos Existentes (modo edição) */}
                                {isEditMode && (
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-semibold text-gray-700 mb-4">
                                            📸 Fotos do Produto
                                        </label>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                            {/* Foto 1 */}
                                            <div className="relative">
                                                <div className="group">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleEditImageUpload(f, 1)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="editFoto1-gal"
                                                    />
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        capture="environment"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleEditImageUpload(f, 1)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="editFoto1-cam"
                                                    />
                                                    <div className="block w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group-hover:scale-105 overflow-hidden">
                                                        {previewFoto1 ? (
                                                            <div
                                                                className="relative w-full h-full"
                                                                title="Duplo clique para ampliar"
                                                                onDoubleClick={(e) => {
                                                                    e.stopPropagation()
                                                                    openImageModal(previewFoto1, 'Foto 1 do produto')
                                                                }}
                                                            >
                                                                <img
                                                                    src={previewFoto1}
                                                                    alt="Foto 1"
                                                                    className="w-full h-full object-cover rounded-2xl"
                                                                />
                                                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-2xl flex items-center justify-center">
                                                                    <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center gap-2 px-2">
                                                                        <PhotoIcon className="w-8 h-8 text-white" />
                                                                        <p className="text-white text-sm text-center">Substituir</p>
                                                                        <div className="flex flex-wrap gap-2 justify-center">
                                                                            <label htmlFor="editFoto1-gal" className="cursor-pointer rounded-lg bg-white/90 px-2 py-1 text-xs font-medium text-gray-800 hover:bg-white">Galeria</label>
                                                                            <label htmlFor="editFoto1-cam" className="cursor-pointer rounded-lg bg-blue-600 px-2 py-1 text-xs font-medium text-white hover:bg-blue-700">Câmera</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center h-full text-gray-500 px-2 py-2">
                                                                <PhotoIcon className="w-12 h-12 mb-2" />
                                                                <p className="text-sm font-medium text-center">Adicionar Foto 1</p>
                                                                <div className="mt-2 flex flex-wrap gap-2 justify-center">
                                                                    <label htmlFor="editFoto1-gal" className="cursor-pointer rounded-lg bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                                    <label htmlFor="editFoto1-cam" className="cursor-pointer rounded-lg bg-blue-100 px-3 py-1.5 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                                </div>
                                                                <p className="text-xs text-gray-400 mt-2 text-center">Galeria ou tirar foto</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Foto 2 */}
                                            <div className="relative">
                                                <div className="group">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleEditImageUpload(f, 2)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="editFoto2-gal"
                                                    />
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        capture="environment"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleEditImageUpload(f, 2)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="editFoto2-cam"
                                                    />
                                                    <div className="block w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group-hover:scale-105 overflow-hidden">
                                                        {previewFoto2 ? (
                                                            <div
                                                                className="relative w-full h-full"
                                                                title="Duplo clique para ampliar"
                                                                onDoubleClick={(e) => {
                                                                    e.stopPropagation()
                                                                    openImageModal(previewFoto2, 'Foto 2 do produto')
                                                                }}
                                                            >
                                                                <img
                                                                    src={previewFoto2}
                                                                    alt="Foto 2"
                                                                    className="w-full h-full object-cover rounded-2xl"
                                                                />
                                                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-2xl flex items-center justify-center">
                                                                    <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center gap-2 px-2">
                                                                        <PhotoIcon className="w-8 h-8 text-white" />
                                                                        <p className="text-white text-sm text-center">Substituir</p>
                                                                        <div className="flex flex-wrap gap-2 justify-center">
                                                                            <label htmlFor="editFoto2-gal" className="cursor-pointer rounded-lg bg-white/90 px-2 py-1 text-xs font-medium text-gray-800 hover:bg-white">Galeria</label>
                                                                            <label htmlFor="editFoto2-cam" className="cursor-pointer rounded-lg bg-blue-600 px-2 py-1 text-xs font-medium text-white hover:bg-blue-700">Câmera</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center h-full text-gray-500 px-2 py-2">
                                                                <PhotoIcon className="w-12 h-12 mb-2" />
                                                                <p className="text-sm font-medium text-center">Adicionar Foto 2</p>
                                                                <div className="mt-2 flex flex-wrap gap-2 justify-center">
                                                                    <label htmlFor="editFoto2-gal" className="cursor-pointer rounded-lg bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                                    <label htmlFor="editFoto2-cam" className="cursor-pointer rounded-lg bg-blue-100 px-3 py-1.5 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                                </div>
                                                                <p className="text-xs text-gray-400 mt-2 text-center">Opcional — galeria ou câmera</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Foto 3 */}
                                            <div className="relative">
                                                <div className="group">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleEditImageUpload(f, 3)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="editFoto3-gal"
                                                    />
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        capture="environment"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleEditImageUpload(f, 3)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="editFoto3-cam"
                                                    />
                                                    <div className="block w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group-hover:scale-105 overflow-hidden">
                                                        {previewFoto3 ? (
                                                            <div
                                                                className="relative w-full h-full"
                                                                title="Duplo clique para ampliar"
                                                                onDoubleClick={(e) => {
                                                                    e.stopPropagation()
                                                                    openImageModal(previewFoto3, 'Foto 3 do produto')
                                                                }}
                                                            >
                                                                <img
                                                                    src={previewFoto3}
                                                                    alt="Foto 3"
                                                                    className="w-full h-full object-cover rounded-2xl"
                                                                />
                                                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-2xl flex items-center justify-center">
                                                                    <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center gap-2 px-2">
                                                                        <PhotoIcon className="w-8 h-8 text-white" />
                                                                        <p className="text-white text-sm text-center">Substituir</p>
                                                                        <div className="flex flex-wrap gap-2 justify-center">
                                                                            <label htmlFor="editFoto3-gal" className="cursor-pointer rounded-lg bg-white/90 px-2 py-1 text-xs font-medium text-gray-800 hover:bg-white">Galeria</label>
                                                                            <label htmlFor="editFoto3-cam" className="cursor-pointer rounded-lg bg-blue-600 px-2 py-1 text-xs font-medium text-white hover:bg-blue-700">Câmera</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center h-full text-gray-500 px-2 py-2">
                                                                <PhotoIcon className="w-12 h-12 mb-2" />
                                                                <p className="text-sm font-medium text-center">Adicionar Foto 3</p>
                                                                <div className="mt-2 flex flex-wrap gap-2 justify-center">
                                                                    <label htmlFor="editFoto3-gal" className="cursor-pointer rounded-lg bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                                    <label htmlFor="editFoto3-cam" className="cursor-pointer rounded-lg bg-blue-100 px-3 py-1.5 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                                </div>
                                                                <p className="text-xs text-gray-400 mt-2 text-center">Opcional — galeria ou câmera</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Dica de uso para edição */}
                                        <div className="mt-4 p-4 bg-blue-50 rounded-2xl border border-blue-200">
                                            <div className="flex items-start space-x-3">
                                                <InformationCircleIcon className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                                                <div>
                                                    <p className="text-sm font-medium text-blue-800">Edição de Fotos</p>
                                                    <p className="text-xs text-blue-600 mt-1">
                                                        Clique nas fotos para substituí-las. As novas fotos substituirão as atuais.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Upload de Imagens (apenas para criação) */}
                                {!isEditMode && (
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-semibold text-gray-700 mb-4">
                                            📸 Imagens do Produto *
                                        </label>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                            {/* Foto 1 */}
                                            <div className="relative">
                                                <div className="group">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleImageUpload(f, setProdutoFoto1, setPreviewFoto1, previewFoto1, null)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="foto1-gal"
                                                    />
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        capture="environment"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleImageUpload(f, setProdutoFoto1, setPreviewFoto1, previewFoto1, null)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="foto1-cam"
                                                    />
                                                    <div className="block w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group-hover:scale-105 overflow-hidden">
                                                        {previewFoto1 ? (
                                                            <div
                                                                className="relative w-full h-full"
                                                                title="Duplo clique para ampliar"
                                                                onDoubleClick={(e) => {
                                                                    e.stopPropagation()
                                                                    openImageModal(previewFoto1, 'Foto 1 do produto')
                                                                }}
                                                            >
                                                                <img
                                                                    src={previewFoto1}
                                                                    alt="Preview 1"
                                                                    className="w-full h-full object-cover rounded-2xl"
                                                                />
                                                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-2xl flex items-center justify-center">
                                                                    <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center gap-2 px-2">
                                                                        <PhotoIcon className="w-8 h-8 text-white" />
                                                                        <p className="text-white text-sm text-center">Substituir</p>
                                                                        <div className="flex flex-wrap gap-2 justify-center">
                                                                            <label htmlFor="foto1-gal" className="cursor-pointer rounded-lg bg-white/90 px-2 py-1 text-xs font-medium text-gray-800 hover:bg-white">Galeria</label>
                                                                            <label htmlFor="foto1-cam" className="cursor-pointer rounded-lg bg-blue-600 px-2 py-1 text-xs font-medium text-white hover:bg-blue-700">Câmera</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center h-full text-gray-500 px-2 py-2">
                                                                <PhotoIcon className="w-12 h-12 mb-2" />
                                                                <p className="text-sm font-medium text-center">Adicionar Foto 1 *</p>
                                                                <div className="mt-2 flex flex-wrap gap-2 justify-center">
                                                                    <label htmlFor="foto1-gal" className="cursor-pointer rounded-lg bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                                    <label htmlFor="foto1-cam" className="cursor-pointer rounded-lg bg-blue-100 px-3 py-1.5 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                                </div>
                                                                <p className="text-xs text-gray-400 mt-2 text-center">Obrigatório — galeria ou câmera</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Foto 2 */}
                                            <div className="relative">
                                                <div className="group">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleImageUpload(f, setProdutoFoto2, setPreviewFoto2, previewFoto2, null)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="foto2-gal"
                                                    />
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        capture="environment"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleImageUpload(f, setProdutoFoto2, setPreviewFoto2, previewFoto2, null)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="foto2-cam"
                                                    />
                                                    <div className="block w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group-hover:scale-105 overflow-hidden">
                                                        {previewFoto2 ? (
                                                            <div
                                                                className="relative w-full h-full"
                                                                title="Duplo clique para ampliar"
                                                                onDoubleClick={(e) => {
                                                                    e.stopPropagation()
                                                                    openImageModal(previewFoto2, 'Foto 2 do produto')
                                                                }}
                                                            >
                                                                <img
                                                                    src={previewFoto2}
                                                                    alt="Preview 2"
                                                                    className="w-full h-full object-cover rounded-2xl"
                                                                />
                                                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-2xl flex items-center justify-center">
                                                                    <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center gap-2 px-2">
                                                                        <PhotoIcon className="w-8 h-8 text-white" />
                                                                        <p className="text-white text-sm text-center">Substituir</p>
                                                                        <div className="flex flex-wrap gap-2 justify-center">
                                                                            <label htmlFor="foto2-gal" className="cursor-pointer rounded-lg bg-white/90 px-2 py-1 text-xs font-medium text-gray-800 hover:bg-white">Galeria</label>
                                                                            <label htmlFor="foto2-cam" className="cursor-pointer rounded-lg bg-blue-600 px-2 py-1 text-xs font-medium text-white hover:bg-blue-700">Câmera</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center h-full text-gray-500 px-2 py-2">
                                                                <PhotoIcon className="w-12 h-12 mb-2" />
                                                                <p className="text-sm font-medium text-center">Adicionar Foto 2</p>
                                                                <div className="mt-2 flex flex-wrap gap-2 justify-center">
                                                                    <label htmlFor="foto2-gal" className="cursor-pointer rounded-lg bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                                    <label htmlFor="foto2-cam" className="cursor-pointer rounded-lg bg-blue-100 px-3 py-1.5 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                                </div>
                                                                <p className="text-xs text-gray-400 mt-2 text-center">Opcional — galeria ou câmera</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Foto 3 */}
                                            <div className="relative">
                                                <div className="group">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleImageUpload(f, setProdutoFoto3, setPreviewFoto3, previewFoto3, null)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="foto3-gal"
                                                    />
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        capture="environment"
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0]
                                                            if (f) handleImageUpload(f, setProdutoFoto3, setPreviewFoto3, previewFoto3, null)
                                                            e.target.value = ''
                                                        }}
                                                        className="hidden"
                                                        id="foto3-cam"
                                                    />
                                                    <div className="block w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group-hover:scale-105 overflow-hidden">
                                                        {previewFoto3 ? (
                                                            <div
                                                                className="relative w-full h-full"
                                                                title="Duplo clique para ampliar"
                                                                onDoubleClick={(e) => {
                                                                    e.stopPropagation()
                                                                    openImageModal(previewFoto3, 'Foto 3 do produto')
                                                                }}
                                                            >
                                                                <img
                                                                    src={previewFoto3}
                                                                    alt="Preview 3"
                                                                    className="w-full h-full object-cover rounded-2xl"
                                                                />
                                                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-2xl flex items-center justify-center">
                                                                    <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center gap-2 px-2">
                                                                        <PhotoIcon className="w-8 h-8 text-white" />
                                                                        <p className="text-white text-sm text-center">Substituir</p>
                                                                        <div className="flex flex-wrap gap-2 justify-center">
                                                                            <label htmlFor="foto3-gal" className="cursor-pointer rounded-lg bg-white/90 px-2 py-1 text-xs font-medium text-gray-800 hover:bg-white">Galeria</label>
                                                                            <label htmlFor="foto3-cam" className="cursor-pointer rounded-lg bg-blue-600 px-2 py-1 text-xs font-medium text-white hover:bg-blue-700">Câmera</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center h-full text-gray-500 px-2 py-2">
                                                                <PhotoIcon className="w-12 h-12 mb-2" />
                                                                <p className="text-sm font-medium text-center">Adicionar Foto 3</p>
                                                                <div className="mt-2 flex flex-wrap gap-2 justify-center">
                                                                    <label htmlFor="foto3-gal" className="cursor-pointer rounded-lg bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                                    <label htmlFor="foto3-cam" className="cursor-pointer rounded-lg bg-blue-100 px-3 py-1.5 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                                </div>
                                                                <p className="text-xs text-gray-400 mt-2 text-center">Opcional — galeria ou câmera</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Dica de uso */}
                                        <div className="mt-4 p-4 bg-blue-50 rounded-2xl border border-blue-200">
                                            <div className="flex items-start space-x-3">
                                                <InformationCircleIcon className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                                                <div>
                                                    <p className="text-sm font-medium text-blue-800">Dica de Upload</p>
                                                    <p className="text-xs text-blue-600 mt-1">
                                                        Selecione imagens de alta qualidade (JPG, PNG, WEBP).
                                                        Pelo menos uma imagem é obrigatória para o produto.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="flex justify-end space-x-4 mt-8">
                                <button
                                    onClick={closeModal}
                                    className="px-6 py-3 text-gray-600 bg-gray-100 rounded-2xl hover:bg-gray-200 transition-all duration-300"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={handleSaveProduto}
                                    disabled={states.isLoading}
                                    className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-2xl hover:shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {states.isLoading ? 'Salvando...' : (isEditMode ? 'Atualizar' : 'Criar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Histórico */}
            {isHistoricoModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
                        <div className="shrink-0 border-b border-gray-200 p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h2 className="text-2xl font-bold text-gray-900">
                                        📋 Histórico de Edições
                                    </h2>
                                    <p className="text-gray-600 mt-1">
                                        {selectedProduto?.modelo} - {selectedProduto?.serial}
                                    </p>
                                </div>
                                <button
                                    onClick={closeHistoricoModal}
                                    className="p-2 text-gray-400 hover:text-gray-600 transition-colors duration-300"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        <div className="min-h-0 flex-1 overflow-y-auto p-6">
                            {loadingHistorico ? (
                                <div className="text-center py-12">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                                    <p className="mt-2 text-gray-600">Carregando histórico...</p>
                                </div>
                            ) : produtoHistorico.length === 0 ? (
                                <div className="text-center py-12">
                                    <ArchiveBoxIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                                    <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum histórico encontrado</h3>
                                    <p className="text-gray-600">Este produto ainda não possui histórico de alterações registradas.</p>
                                </div>
                            ) : (
                                <div className="space-y-6">
                                    <div className="text-center mb-6">
                                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                            Cronologia de Alterações
                                        </h3>
                                        <p className="text-sm text-gray-600">
                                            Visualize todo o histórico de edições do produto
                                        </p>
                                    </div>

                                    <div className="relative">
                                        {/* Linha do tempo */}
                                        <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-blue-500 to-purple-600"></div>

                                        {/* Items da cronologia */}
                                        <div className="space-y-8">
                                            {produtoHistorico.map((historico, index) => (
                                                <div
                                                    key={historico.id}
                                                    className="relative flex items-start space-x-6 animate-fade-in"
                                                    style={{ animationDelay: `${index * 200}ms` }}
                                                >
                                                    {/* Ícone da movimentação */}
                                                    <div className="relative z-10 flex-shrink-0">
                                                        <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-lg">
                                                            <span className="text-white text-lg font-bold">
                                                                {index + 1}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Conteúdo da movimentação */}
                                                    <div className="flex-1 bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300">
                                                        <div className="flex items-center justify-between mb-4">
                                                            <div className="flex items-center space-x-3">
                                                                <div className={`px-3 py-1 rounded-full text-xs font-medium ${historico.transformacao === 'Criação' ? 'bg-green-100 text-green-800' :
                                                                    historico.transformacao === 'Edição' ? 'bg-blue-100 text-blue-800' :
                                                                        'bg-gray-100 text-gray-800'
                                                                    }`}>
                                                                    {historico.transformacao}
                                                                </div>
                                                                <div className="px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                                                    {historico.user_email}
                                                                </div>
                                                            </div>
                                                            <div className="text-xs text-gray-500">
                                                                {new Date(historico.data_atualizacao).toLocaleDateString('pt-BR')}
                                                                <br />
                                                                {new Date(historico.data_atualizacao).toLocaleTimeString('pt-BR')}
                                                            </div>
                                                        </div>

                                                        <div className="space-y-3">
                                                            {historico.transformacao === 'Criação' ? (
                                                                <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                                                    <h4 className="font-medium text-green-800 mb-2">Produto Criado</h4>
                                                                    <div className="grid grid-cols-2 gap-2 text-sm">
                                                                        <div><span className="font-medium">Modelo:</span> {historico.dado_atual.modelo}</div>
                                                                        <div><span className="font-medium">Serial:</span> {historico.dado_atual.serial}</div>
                                                                        <div><span className="font-medium">Status:</span> {historico.dado_atual.status === '1' ? 'Ativo' : 'Inativo'}</div>
                                                                        <div><span className="font-medium">Condição:</span> {getCondicaoText(Number(historico.dado_atual.condicao))}</div>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                                                    <h4 className="font-medium text-blue-800 mb-2">Alterações Realizadas</h4>
                                                                    <div className="space-y-2 text-sm">
                                                                        {historico.dado_atual.modelo !== historico.dado_antigo.modelo && (
                                                                            <div className="flex items-center space-x-2">
                                                                                <span className="font-medium">Modelo:</span>
                                                                                <span className="text-red-600 line-through">{historico.dado_antigo.modelo}</span>
                                                                                <span className="text-green-600">→ {historico.dado_atual.modelo}</span>
                                                                            </div>
                                                                        )}
                                                                        {historico.dado_atual.status !== historico.dado_antigo.status && (
                                                                            <div className="flex items-center space-x-2">
                                                                                <span className="font-medium">Status:</span>
                                                                                <span className="text-red-600">{historico.dado_antigo.status === 1 ? 'Ativo' : 'Inativo'}</span>
                                                                                <span className="text-green-600">→ {historico.dado_atual.status === '1' ? 'Ativo' : 'Inativo'}</span>
                                                                            </div>
                                                                        )}
                                                                        {historico.dado_atual.condicao !== historico.dado_antigo.condicao && (
                                                                            <div className="flex items-center space-x-2">
                                                                                <span className="font-medium">Condição:</span>
                                                                                <span className="text-red-600">{getCondicaoText(Number(historico.dado_antigo.condicao))}</span>
                                                                                <span className="text-green-600">→ {getCondicaoText(Number(historico.dado_atual.condicao))}</span>
                                                                            </div>
                                                                        )}
                                                                        {historico.dado_atual.observacao !== historico.dado_antigo.observacao && (
                                                                            <div className="flex items-center space-x-2">
                                                                                <span className="font-medium">Observação:</span>
                                                                                <span className="text-red-600 line-through">{historico.dado_antigo.observacao}</span>
                                                                                <span className="text-green-600">→ {historico.dado_atual.observacao}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="mt-4 pt-4 border-t border-gray-100">
                                                            <div className="flex items-center justify-between text-xs text-gray-500">
                                                                <span>Criado: {new Date(historico.data_criacao).toLocaleDateString('pt-BR')}</span>
                                                                <span>Atualizado: {new Date(historico.data_atualizacao).toLocaleDateString('pt-BR')}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Visualização */}
            {isViewModalOpen && viewProduto && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
                        <div className="shrink-0 border-b border-gray-200 p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h2 className="text-2xl font-bold text-gray-900">
                                        📦 Visualizar Produto
                                    </h2>
                                    <p className="text-gray-600 mt-1">
                                        {viewProduto.modelo} - Código NET: #{viewProduto.codigo_net}
                                    </p>
                                </div>
                                <button
                                    onClick={closeViewModal}
                                    className="p-2 text-gray-400 hover:text-gray-600 transition-colors duration-300"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        <div className="min-h-0 flex-1 overflow-y-auto p-6">
                            {/* Informações do Produto */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Modelo</label>
                                        <p className="text-gray-900">{viewProduto.modelo}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Código NET</label>
                                        <p className="text-gray-900">#{viewProduto.codigo_net}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Serial</label>
                                        <p className="text-gray-900">{viewProduto.serial}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Status</label>
                                        <p className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${viewProduto.status === 1 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                            }`}>
                                            {viewProduto.status === 1 ? 'Ativo' : 'Inativo'}
                                        </p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Condição</label>
                                        <p className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${viewProduto.condicao === 0 ? 'bg-blue-100 text-blue-800' :
                                            viewProduto.condicao === 1 ? 'bg-orange-100 text-orange-800' :
                                                viewProduto.condicao === 2 ? 'bg-green-100 text-green-800' :
                                                    viewProduto.condicao === 3 ? 'bg-red-100 text-red-800' :
                                                        viewProduto.condicao === 5 ? 'bg-orange-100 text-orange-800' :
                                                            'bg-gray-100 text-gray-800'
                                            }`}>
                                            {getCondicaoText(viewProduto.condicao)}
                                        </p>
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Equipamento</label>
                                        <p className="text-gray-900">{viewProduto.equipamento_nome}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Formato do Equipamento</label>
                                        <p className="text-gray-900">{viewProduto.equipamento_formato_nome}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Marca</label>
                                        <p className="text-gray-900">{viewProduto.marca_nome}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Fornecedor</label>
                                        <p className="text-gray-900">{viewProduto.nome}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Localização Atual */}
                            <div className="mb-8">
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">📍 Localização Atual</h3>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Entidade</label>
                                        <p className="text-gray-900">{viewProduto.entidade_atual_nome}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Local</label>
                                        <p className="text-gray-900">{viewProduto.local_atual_nome}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Departamento</label>
                                        <p className="text-gray-900">{viewProduto.departamento_atual_nome}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Características do Produto */}
                            {viewProduto.caracteristicas && viewProduto.caracteristicas.length > 0 && (
                                <div className="mb-8">
                                    <h3 className="text-lg font-semibold text-gray-900 mb-4">⚙️ Características</h3>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                        {viewProduto.caracteristicas.map((caracteristica, index) => (
                                            <div key={caracteristica.caracteristica_id || index} className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100 hover:shadow-md transition-all duration-300">
                                                <div className="flex items-start space-x-3">
                                                    <div className="flex-shrink-0">
                                                        <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center">
                                                            <span className="text-white text-xs font-bold">⚙️</span>
                                                        </div>
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <h4 className="text-sm font-semibold text-gray-900 mb-1 truncate">
                                                            {caracteristica.caracteristica_chave}
                                                        </h4>
                                                        <p className="text-sm text-gray-700 break-words">
                                                            {caracteristica.caracteristica_valor}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Fotos do Produto */}
                            <div className="mb-8">
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">📸 Fotos do Produto</h3>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    {viewProduto.path_foto1 && viewProduto.path_foto1 !== 'null' && viewProduto.path_foto1 !== 'base64' && viewProduto.path_foto1.length > 100 ? (
                                        <div className="bg-white rounded-lg overflow-hidden border border-gray-200 cursor-pointer hover:shadow-lg transition-all duration-300 group relative" onClick={() => openImageModal(`data:image/webp;base64,${viewProduto.path_foto1}`, 'Foto 1 do Produto')}>
                                            <img
                                                src={`data:image/webp;base64,${viewProduto.path_foto1}`}
                                                alt="Foto 1"
                                                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextSibling.style.display = 'flex';
                                                }}
                                            />
                                            <div className="bg-gray-200 rounded-lg flex items-center justify-center hidden h-48">
                                                <PhotoIcon className="w-8 h-8 text-gray-400" />
                                            </div>
                                            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-lg flex items-center justify-center">
                                                <div className="opacity-0 group-hover:opacity-100 transition-all duration-300">
                                                    <div className="bg-white rounded-lg p-2 shadow-lg">
                                                        <PhotoIcon className="w-6 h-6 text-gray-600" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="bg-gray-200 rounded-lg flex items-center justify-center h-48">
                                            <PhotoIcon className="w-8 h-8 text-gray-400" />
                                        </div>
                                    )}

                                    {viewProduto.path_foto2 && viewProduto.path_foto2 !== 'null' && viewProduto.path_foto2 !== 'base64' && viewProduto.path_foto2.length > 100 ? (
                                        <div className="bg-white rounded-lg overflow-hidden border border-gray-200 cursor-pointer hover:shadow-lg transition-all duration-300 group relative" onClick={() => openImageModal(`data:image/webp;base64,${viewProduto.path_foto2}`, 'Foto 2 do Produto')}>
                                            <img
                                                src={`data:image/webp;base64,${viewProduto.path_foto2}`}
                                                alt="Foto 2"
                                                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextSibling.style.display = 'flex';
                                                }}
                                            />
                                            <div className="bg-gray-200 rounded-lg flex items-center justify-center hidden h-48">
                                                <PhotoIcon className="w-8 h-8 text-gray-400" />
                                            </div>
                                            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-lg flex items-center justify-center">
                                                <div className="opacity-0 group-hover:opacity-100 transition-all duration-300">
                                                    <div className="bg-white rounded-lg p-2 shadow-lg">
                                                        <PhotoIcon className="w-6 h-6 text-gray-600" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="bg-gray-200 rounded-lg flex items-center justify-center h-48">
                                            <PhotoIcon className="w-8 h-8 text-gray-400" />
                                        </div>
                                    )}

                                    {viewProduto.path_foto3 && viewProduto.path_foto3 !== 'null' && viewProduto.path_foto3 !== 'base64' && viewProduto.path_foto3.length > 100 ? (
                                        <div className="bg-white rounded-lg overflow-hidden border border-gray-200 cursor-pointer hover:shadow-lg transition-all duration-300 group relative" onClick={() => openImageModal(`data:image/webp;base64,${viewProduto.path_foto3}`, 'Foto 3 do Produto')}>
                                            <img
                                                src={`data:image/webp;base64,${viewProduto.path_foto3}`}
                                                alt="Foto 3"
                                                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextSibling.style.display = 'flex';
                                                }}
                                            />
                                            <div className="bg-gray-200 rounded-lg flex items-center justify-center hidden h-48">
                                                <PhotoIcon className="w-8 h-8 text-gray-400" />
                                            </div>
                                            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-lg flex items-center justify-center">
                                                <div className="opacity-0 group-hover:opacity-100 transition-all duration-300">
                                                    <div className="bg-white rounded-lg p-2 shadow-lg">
                                                        <PhotoIcon className="w-6 h-6 text-gray-600" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="bg-gray-200 rounded-lg flex items-center justify-center h-48">
                                            <PhotoIcon className="w-8 h-8 text-gray-400" />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Arquivo da Nota Fiscal */}
                            {viewProduto.nota_path && viewProduto.nota_path !== 'null' && viewProduto.nota_path !== 'base64' && viewProduto.nota_path.length > 100 ? (
                                <div className="mb-8">
                                    <h3 className="text-lg font-semibold text-gray-900 mb-4">📄 Nota Fiscal</h3>
                                    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                                        <div className="relative w-full h-96">
                                            {/* Header com informações do arquivo */}
                                            <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-red-500 to-red-600 text-white p-3 z-10">
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center space-x-2">
                                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                                        </svg>
                                                        <span className="text-sm font-medium truncate">
                                                            {viewProduto.nota_arquivo || 'Nota Fiscal.pdf'}
                                                        </span>
                                                    </div>
                                                    <span className="text-sm">PDF</span>
                                                </div>
                                            </div>

                                            {/* Pré-visualização do PDF */}
                                            <iframe
                                                src={`data:application/pdf;base64,${viewProduto.nota_path}#toolbar=0&navpanes=0&scrollbar=1`}
                                                className="w-full h-full border-0 mt-12"
                                                title="Pré-visualização da Nota Fiscal"
                                                style={{ height: 'calc(100% - 3rem)' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {/* Informações Adicionais */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">Número da Nota</label>
                                    <p className="text-gray-900">{viewProduto.numero_nota || 'Não informado'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">Data de Aquisição</label>
                                    <p className="text-gray-900">{viewProduto.data_aquisicao ? new Date(viewProduto.data_aquisicao).toLocaleDateString('pt-BR') : 'Não informado'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">Observações</label>
                                    <p className="text-gray-900">{viewProduto.observacao || 'Sem observações'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isExportModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl">
                        <div className="border-b border-gray-200 p-6">
                            <div className="flex items-center justify-between">
                                <h2 className="text-xl font-bold text-gray-900">Exportar e enviar por e-mail</h2>
                                <button
                                    onClick={() => setIsExportModalOpen(false)}
                                    className="p-2 text-gray-400 hover:text-gray-600 transition-colors duration-300"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>
                        <div className="p-6">
                            <p className="text-sm text-gray-700 mb-6">
                                Enviar {idsSelecionados.length} item(ns) para {emailUsuario}?
                            </p>
                            <div className="flex items-center justify-end space-x-3">
                                <button
                                    onClick={() => setIsExportModalOpen(false)}
                                    className="px-4 py-2 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={confirmarExportacaoProdutos}
                                    disabled={states.isLoading}
                                    className="px-4 py-2 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-xl text-sm font-medium hover:shadow-md disabled:opacity-50"
                                >
                                    Enviar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <ZoomableImageModal
                isOpen={isImageModalOpen}
                onClose={closeImageModal}
                src={expandedImage}
                alt={expandedImageAlt}
            />
        </div>
    )
}

export default Produtos